<template>
  <div v-if="isEnabled('bins-workspace')" class="resizable-panel">
    <customAlertMessage v-if="enableCustomMessage" v-bind="alertMessageProperties" @close="enableCustomMessage = false"></customAlertMessage>
    <div v-if="vdialogComponents.includes(openTagMetadataModel)">
      <component
        :is="openTagMetadataModel"
        v-bind="currentProperties"
        :folderInfoToGetCurrentPath="folderInfoToGetCurrentPath"
        :isFolderExists="isFolderExists"
        v-if="isMetadataManagerVisible"
        :ref="'modal'+openTagMetadataModel"
        @close="closeModal"
      ></component>
    </div>
    <div v-else>
      <router-view
        :name="openTagMetadataModel"
        v-bind="currentProperties"
        :folderInfoToGetCurrentPath="folderInfoToGetCurrentPath"
        :isFolderExists="isFolderExists"
        v-if="isMetadataManagerVisible"
        @close="closeModal"
        @openSubclipWindow="openSubclipWindow"
        @openVideoTranscriptWindow="openVideoTranscriptWindow"
        :ref="'modal'+openTagMetadataModel"
        @AIComponentNavigation="traverseToAIComp"
      ></router-view>
    </div>
    <!-- <sub-clips-manager v-if="openSubclips" v-bind="currentProperties" @close="closeSubclip"></sub-clips-manager> -->
    <div ref="fadeWhenModelOpen" style="height: 100%;">
      <top-nav
        @changeDirectoryFromUrl="changeDir" 
        @changeComponent="changeComponent"
        :getCookieValueOfJobPanel="getCookieValueOfJobPanel"
        :dirs="dirs"
        compoentType="BinWorkspace"
         usedBy="Bins"
         ref="top_nav_bar"
        :sortedOption="sortBy"
        v-on:sort-by-filter-updated="sortBinsTable"
        @fileStateFilterUpdated="updateFileStateFilter"
        @reloadThePage="reloadThePage"
        @changeJobsPanelState="changeJobsPanelState"
      ></top-nav>
      <div
        class="assets-view-wrapper"
        :style="setHeightOfTheTable()"
        v-if="viewType == true"
        @click="deselectFileAndContextMenu"
        @contextmenu="show($event, selectedFileInfo)"
        :ripple="false"
        data-app
        >
        <div v-if="filesList.files.length == 0 && filesList.dirs.length == 0">
          <div style="font-size: 20px; margin-top: 8%; color: #686868;">
            No Data Found
          </div>
        </div>
        <div v-if="filesList.dirs.length !== 0">
          <div
            class="text-left"
            style="padding: 10px 0px 0px 20px; color: #777"
          >
          <svg  v-if="!showFolders" v-on:click.stop.prevent="showFolders = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
            <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
          </svg>
          <svg v-if="showFolders" v-on:click.stop.prevent="showFolders = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg>
            {{$t('Folders')}}
          </div>
          <ul v-if="showFolders" class="thumbnail-view-ul folder-view-ul">
            <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
            <li
              class="folder-view-li"
              v-for="file in filesList.dirs"
              :key="file.file_uid"
              :attr="file.file_uid"
              @click.ctrl="multiSelectElemet(file)"
              @click.meta="multiSelectElemet(file)"
              @click.exact="selectElement($event, file)"
              @dblclick="showAssetDetails(file)"
              :class="{ activeFolder: isFileSelected(file), 'reduce-opacity': file.state == 'MARK FOR DELETE' }"
              @contextmenu="show($event, file)"
              :ripple="false"
              :title="file.dir_name"
              data-app
              >
              <div class="folder-view" :class="file.state == 'MARK FOR DELETE'?'reduce-opacity':' '">
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  class="bi bi-folder-fill"
                  fill="#939393"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"
                  />
                </svg>
                <img v-if="file.state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :50%;">
              </div>
              <div class="folder-data">
                {{ file.dir_name }}
              </div>
            </li>
          </drag-select-container>
          </ul>
        </div>
        <div v-if="filesList.files.length !== 0">
          <div style="display: flex;justify-content: flex-start;align-items: center;">
            <input v-on:change.stop="selectAllFiles" v-model='allFilesSelected' type="checkbox" class="text-light ml-4 bigger-checkboxes" style="position: relative;top: 3px;">
            <div class="text-left" style="padding: 10px 0px 0px 10px; color: #777">
              <svg  v-if="!showFiles" v-on:click.stop.prevent="showFiles = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <svg v-if="showFiles" v-on:click.stop.prevent="showFiles = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
              {{$t('Files')}}
            </div>
          </div>
          <ul v-if="showFiles" class="thumbnail-view-ul common-view-ul">
            <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
            <li
              v-for="file in filesList.files"
              :key="file.file_uid"
              :attr="file.file_uid"
              @click.ctrl="multiSelectElemet(file)"
              @click.meta="multiSelectElemet(file)"
              @click.exact="selectElement($event, file)"
              @dblclick="showAssetDetails(file)"
              :class="{ activeAsset: isFileSelected(file) }"
              @contextmenu="show($event, file)"
              :ripple="false"
              data-app
              style="position:relative"
              :title="getDisplayFN(file)"
               @mousemove="handleMouseMoveForStoryBoardPreview($event,file)"
               @mouseleave="storyboardPreviewActiveId = null"
            >
              <div class="asset-thumbnail" onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue=false" >
                <div class="thumbnail-view" style="height: 93px;width: 160px;position: relative;align-items: center;display: inline-flex;justify-content:center;" :class="file.state == 'MARK FOR DELETE' || file.state == 'ERROR'?'reduce-opacity':' '">
                   <StoryBoardImagePreview :ref="'storyboard'+file._id" v-if="getFileMimeType(file) == 'video' && storyboardPreviewActiveId == file._id" :assetDetails="file"></StoryBoardImagePreview>
                  <img :src="getThumbnailPath(file,'FOR_SVG_THUMBNAIL')" @error="(e) => replaceByDefaultImage(e,file,'FOR_SVG_THUMBNAIL')" alt="image" draggable="false"/>
                  <div v-if="'mime_type' in file && (file.mime_type.startsWith('video') || file.mime_type.startsWith('audio')) && 'duration' in file && file.duration"
                          class="comm-thumbnail-view-duration-label">
                          {{getHumanReadableDuration(file.duration)}}
                  </div>
                  <div v-if='checkIfDisabled(file)' :id="'assetResolution_'+file._id" class="thumbnail-view-resolution-label">
                    {{ getReadableResolutionValue(file) }}
                  </div>
                
                </div>
                <div class="storage-type-icons-wrapper"  v-if="(file.storage_class != undefined && file.storage_class.length) || file.subclips_present == true || (Object.keys(file).includes('ttl') && file.ttl) || file.location_info && (Object.keys(file.location_info).includes('alto')|| Object.keys(file.location_info).includes('gravity_deep') || file.asset_type == 'subclip' || 'lock' in file)">
                  <template v-if="file.state != 'MARK FOR DELETE' && Object.keys(file).includes('ttl') && file.ttl">
                      <div v-if="loadTTLIcons(file.ttl)" v-html="loadTTLIcons(file.ttl)" style="width: 22px;"></div>
                    </template>
                  <svg v-if="file.subclips_present == true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                    <title>Have subclips</title>
                  </svg>
                  <svg v-if="'lock' in file && file.lock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18" height="18" style="position: relative;top: -1px;">
                    <path fill="#cdcdcd" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z" style=""></path>
                    <path fill="#e98405" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z" style=""></path>
                    <path fill="#55524e" d="M24 28A3 3 0 1 0 24 34A3 3 0 1 0 24 28Z" style=""></path>
                    <title>{{$t('Locked')}}</title>
                  </svg>
                  <div v-if="file.asset_type == 'subclip'" style="position:relative;inset-inline-start:4px;width:30px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                      <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                      <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                      <title>Subclip</title>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;">
                      <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                      <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                      <title>Subclip</title>
                    </svg>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                    <title>Amazon S3 Glacier</title>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Deep Archive')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                    <title>Amazon S3 Glacier Deep Archive</title>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                    <title>Amazon S3 Glacier Instant Retrieval</title>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Standard')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                    <title>Amazon S3 Standard</title>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" v-if="Object.keys(file).includes('archived') && file.archived" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16">
                    <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                    <title>Archived</title>
                  </svg>
                  <template v-if="'location_info' in file && 'gravity_deep' in file.location_info">
                    <div v-for="cId of file.location_info.gravity_deep.container_ids" :key="cId">
                      <svg v-if="cId == 'CACHE'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-square" viewBox="0 0 16 16">
                        <title>{{ cId }}</title>
                        <path d="M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"/>
                        <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"/>
                      </svg>
                      <svg v-else-if="cId.startsWith('Tape')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cassette-fill" viewBox="0 0 16 16">
                        <title>{{ cId }}</title>
                        <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"/>
                        <path d="m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"/>
                      </svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                        <title>{{ cId }}</title>
                        <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                      </svg>
                    </div>
                  </template>
                  <img v-if="file.location_info && Object.keys(file.location_info).includes('alto')" title="ALTO" :src="altoLogo" alt="alto"/>
                </div>
                <div v-if="!['GROWING'].includes(file.state)" class="shortcut-actions-type-icons-wrapper" style="z-index:2;">
                  <template v-if="!['MARK FOR DELETE'].includes(file.state) &&
                           !['no-access','browse'].includes(file.permissions) &&
                                      (Object.keys(selectedFileInfo).length >= 1 || Object.keys(selectedFiles).length == 1 ||
                                        Object.keys(selectedFileInfo).length <= 0 && Object.keys(selectedFiles).length <= 0 ||
                                          !isFileSelected(file))">
                    <svg v-if="!lockRestrictedAction('Download', file) && isFileActionEnabled('Download', file.permissions)" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                      <title>{{$t('Download')}}</title>
                      <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                      <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                    </svg>
                    <svg v-if="!lockRestrictedAction('Share', file) && isFileActionEnabled('Share', file.permissions)" @click="handleShareAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-share-fill" viewBox="0 0 16 16">
                      <title>{{$t('Share')}}</title>
                      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                    </svg>
                    <svg v-if="(!lockRestrictedAction('tag-metadata', file) || !lockRestrictedAction('tag-metadata-requestor',file)) && (isFileActionEnabled('tag-metadata',file.permissions) || isFileActionEnabled('tag-metadata-requestor',file.permissions))" @click="handleTagMetadataAssetHoverAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-tag-fill" viewBox="0 0 16 16">
                      <title>{{$t('Tag Metadata')}}</title>
                      <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                    </svg>
                  </template>
                  <svg v-if="!lockRestrictedAction('Preview',file)" @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <title>{{$t('Preview')}}</title>
                    <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                  </svg>
                  <div class="overflow-parent-div">
                    <svg @click="eOMenu=true;selectElement($event,file,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                      <title>{{$t('More actions')}}</title>
                      <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                    </svg>
                    <!-- <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                          <div class="dropdown-item p-2 copy-link-action" @click="setClipBoardText(file)" title="Copy link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fdfff4" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                            </svg>
                            Copy link</div>
                            <div v-if="isEnabled('Chat')" class="dropdown-item p-2 copy-link-action" @click="openShareInChat()" title="">
                              <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-share-fill" viewBox="0 0 16 16">
                                <title></title>
                                <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                              </svg>
                              Share in chat</div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="thumbnail-data d-inline-flex" style="float:inline-start;width:100%">
                <div
                  v-html="getSvgIconsOfMediaTypes(file)" 
                  class="svg-icons-display"
                  >
                </div>
                <div class="file-name" :title="getDisplayFN(file)" v-if="!getHighlightFilename(file,file.slug_name).highlight" :style="globalSettingsFromStartup.enable_file_extension?'':'max-width:140px !important'" style="display:flex">
                  <span class="dynamic-slug-name">{{ getDisplayFN(file) }}</span>
                  <span class="file-extension-thumbnail-view" v-if="globalSettingsFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
                </div>
                <div class="file-name" :title="getDisplayFN(file)" v-else :style="globalSettingsFromStartup.enable_file_extension?'':'max-width:140px !important'" style="display:flex">
                  <span class="dynamic-slug-name" v-html="getHighlightFilename(file,file.slug_name).slugname"></span>
                  <span class="file-extension-thumbnail-view" v-if="globalSettingsFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
                </div>
              </div>
              <div v-if="file.state == 'GROWING'">
                <img
                  :src="growingFileGif"
                  alt="loading"
                  style="height:50px;width:65px;position:absolute;bottom:40%;inset-inline-start:28%"
                />
              </div>
              <div v-else-if="file.state == 'ERROR'">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:49%;inset-inline-start:41%">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                    <title>ERROR</title>
                </svg>
              </div>
              <div v-else-if="file.state == 'MARK FOR DELETE'">
                <img
                  :src="markForDeleteIcn"
                  alt="markfordelete"
                  style="height:25px;width:29px;position:absolute;bottom:47%;inset-inline-start:42%"
                />
              </div>
              <!-- <div v-html="getMediaTypeIcons(file.mime_type)" style="position: absolute;bottom: 42%;inset-inline-start:38%;"></div> -->
            </li>
            </drag-select-container>
          </ul>
        </div>
      </div>
      <div
        class="list-view-wrapper"
        :style="setHeightOfTheTable()"
        v-if="viewType == false"
        @click="deselectFileAndContextMenu"
        @contextmenu="show($event, selectedFileInfo)"
        :ripple="false"
        data-app
        >
        <table
          class="tabletable-with-border table-scroll small-first-col"
          style="background: transparent;width:98%;white-space: initial;"
        >
          <thead>
            <tr style="height:40px">
              <!-- <th style="width:2%">
             <td>
              <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" v-model="allSelected"/>
            </td>
          </th> -->
              <th style="width:8%"></th>
              <th style="width:62%;text-align:start">{{$t('Slugname')}}</th>
              <th
                style="width:10%"
                v-if="
                  !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                "
              >
                {{$t('Date Created')}}
              </th>
              <th
                style="width:10%"
                v-if="
                  !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                "
              >
                {{$t('Date Added')}}
              </th>
              <th
                style="width:20%;text-align:center"
                v-if="
                  !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                "
              >
                {{$t('Size')}}
              </th>
              <!-- <th
                style="width:10%;text-align:center"
                v-if="
                  !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                "
              >
                Type
              </th> -->
            </tr>
          </thead>
          <tbody>
              <template v-if="filesList.dirs.length">
                <div style="align-items: baseline;display: flex;justify-content: flex-start;color: #777">
                  <div
                    class="text-left" style="padding: 10px 0px 0px 20px; color: #777;margin: 11px;">
                    <svg  v-if="!showFoldersInListView" v-on:click.stop.prevent="showFoldersInListView = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                      <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                    </svg>
                    <svg v-if="showFoldersInListView" v-on:click.stop.prevent="showFoldersInListView = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                      <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                    </div>
                    <div>{{$t('Folders')}}</div>
                </div>
                <template v-if="showFoldersInListView">
                <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
                  <template v-for="file in filesList.dirs">
                    <tr
                      :key="file.file_uid"
                      :attr="file.file_uid"
                      @click.ctrl="multiSelectElemet(file)"
                      @click.meta="multiSelectElemet(file)"
                      @click.exact="selectElement($event, file)"
                      @dblclick="showAssetDetails(file, 'list-view')"
                      class="active-list-view"
                      :class="{ activeAsset: isFileSelected(file) , 'reduce-opacity': file.state == 'MARK FOR DELETE'}"
                      @contextmenu="show($event, file)"
                      :ripple="false"
                      data-app
                      >
                      <!-- <td>
                      <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" v-model="selected" :value="file.file_uid"/>
                      </td> -->
                      <td :title="file.dir_name" style="padding-inline-start:15px;padding-top:11px">
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            fill="#858585"
                            class="bi bi-folder-fill"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"
                            />
                          </svg>
                        <img v-if="file.state == 'MARK FOR DELETE'" :src="markForDeleteIcn" alt="markfordelete" style="height: 20px;width: 20px;position: relative;inset-inline-end :44%;">
                        </div>
                      </td>
                      <td style="text-align:start;padding-inline-start:15px" :title="file.dir_name">{{ file.dir_name }}</td>
                      <td
                      style="padding-inline-start:15px"
                        v-if="
                          !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                        "
                        :title="getDateAndTimeInConfiguredFormat(file.created_datetime)"
                      >
                        {{ getDateAndTimeInConfiguredFormat(file.created_datetime, true) }}
                      </td>
                      <td
                      style="padding-inline-start:15px"
                        v-if="
                          !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                        "
                        :title="getDateAndTimeInConfiguredFormat(file.added_datetime)"
                      >
                        {{ getDateAndTimeInConfiguredFormat(file.added_datetime, true) }}
                      </td>
                      <td
                        style="text-align:end,padding-inline-start:15px"
                        v-if="
                          !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                        "
                      >
                        -
                      </td>
                      <!-- <td
                        style="text-align:center"
                        v-if="
                          !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                        "
                      >
                        Folder
                      </td> -->
                    </tr>
                  </template>
                </drag-select-container>
              </template>
              </template>
              <template v-if="filesList && filesList.files.length">
                <div style="display: flex;justify-content: flex-start;align-items: flex-start;margin: 10px;">
                  <input v-on:change.stop="selectAllFiles" v-model='allFilesSelected' type="checkbox" class="text-light ml-4 bigger-checkboxes" style="margin-inline-start: -5px !important;">
                  <div 
                    class="text-left"  style="padding: 2px 0px 0px 10px; color: #777;display: flex;align-items: center;">
                    <div>
                      <svg  v-if="!showFilesInListView" v-on:click.stop.prevent="showFilesInListView = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                        <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                      </svg>
                      <svg v-if="showFilesInListView" v-on:click.stop.prevent="showFilesInListView = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                        <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                    </div>
                    <div>
                      {{$t('Files')}}
                    </div>
                  </div>
                </div>
                <template v-if="showFilesInListView">
                <drag-select-container name="drag-select-container" style="display:contents" attribute="attr" @change="dragSelect($event)">
                  <template  v-for="file in filesList.files">
                    <tr
                      :key="file.file_uid"
                      :attr="file.file_uid"
                      @click.ctrl="multiSelectElemet(file)"
                      @click.meta="multiSelectElemet(file)"
                      @click.exact="selectElement($event, file)"
                      @dblclick="showAssetDetails(file, 'list-view')"
                      :class="{ activeAsset: isFileSelected(file) }"
                      class="active-list-view"
                      @contextmenu="show($event, file)"
                      :ripple="false"
                      data-app
                      :title="getDisplayFN(file)"
                    >
                      <!-- <td>
                      <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" v-model="selected" :value="file.file_uid"/>
                    </td> -->
                      <td style="padding:10px">
                        <div style="padding:8px 0px;position:relative" :title="getDisplayFN(file)">
                          <div  class="asset-thumbnail asset-thumbnail-hw-set"  onmousedown="event.preventDefault ? event.preventDefault() : event.returnValue=false">
                              <div  class="thumbnail-hw-set"  @mousemove="handleMouseMoveForStoryBoardPreview($event,file)" @mouseleave="storyboardPreviewActiveId = null" :class="file.state == 'MARK FOR DELETE' || file.state == 'ERROR'?'reduce-opacity':' '">
                                 <StoryBoardImagePreview :ref="'storyboard'+file._id" v-if="getFileMimeType(file) == 'video' && storyboardPreviewActiveId == file._id" :assetDetails="file"></StoryBoardImagePreview>
                              <img :src="getThumbnailPath(file,'FOR_SVG_THUMBNAIL')" @error="(e) => replaceByDefaultImage(e,file,'FOR_SVG_THUMBNAIL')" alt="image" draggable="false"/>
                              <div v-if="'mime_type' in file && (file.mime_type.startsWith('video') || file.mime_type.startsWith('audio')) && 'duration' in file && file.duration"
                                class="comm-thumbnail-view-duration-label">
                                {{getHumanReadableDuration(file.duration)}}
                              </div>
                              <div v-if='checkIfDisabled(file)' :id="'assetResolution_'+file._id" class="thumbnail-view-resolution-label">
                                {{ getReadableResolutionValue(file) }}
                              </div>
                              <div class="storage-type-icons-wrapper" v-if="(file.storage_class != undefined && file.storage_class.length) || file.asset_type == 'subclip' || file.subclips_present == true || (Object.keys(file).includes('ttl') && file.ttl) || (file.location_info && (Object.keys(file.location_info).includes('alto')|| Object.keys(file.location_info).includes('gravity_deep')) || 'lock' in file)" style="inset-inline-end:0px;z-index:2;">
                                <template v-if="file.state != 'MARK FOR DELETE' && Object.keys(file).includes('ttl') && file.ttl">
                                  <div v-if="loadTTLIcons(file.ttl)" v-html="loadTTLIcons(file.ttl)" style="width: 22px;"></div>
                                </template>
                                <svg v-if="file.subclips_present == true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                  <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                  <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                  <title>{{$t('Have subclips')}}</title>
                                </svg>
                                <svg v-if="'lock' in file && file.lock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18" height="18" style="position: relative;top: -1px;">
                                  <path fill="#cdcdcd" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z" style=""></path>
                                  <path fill="#e98405" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z" style=""></path>
                                  <path fill="#55524e" d="M24 28A3 3 0 1 0 24 34A3 3 0 1 0 24 28Z" style=""></path>
                                  <title>{{$t('Locked')}}</title>
                                </svg>
                                <div v-if="file.asset_type == 'subclip'" style="position:relative;inset-inline-start:4px;width:30px">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                    <title>{{$t('Subclip')}}</title>
                                  </svg>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;">
                                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                                    <title>{{$t('Subclip')}}</title>
                                  </svg>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Deep Archive')" width="16" height="16" :fill="getColorBasedOnExpiry(file.location_info)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier Deep Archive')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Glacier Instant Retrieval')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Glacier Instant Retrieval')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="file.storage_class != undefined && file.storage_class.includes('Amazon S3 Standard')" width="16" height="16" fill="#28a745" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                  <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                  <title>{{$t('Amazon S3 Standard')}}</title>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" v-if="Object.keys(file).includes('archived') && file.archived" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16">
                                  <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                                  <title>{{$t('Archived')}}</title>
                                </svg>
                                <template v-if="'location_info' in file && 'gravity_deep' in file.location_info">
                                  <div v-for="cId of file.location_info.gravity_deep.container_ids" :key="cId">
                                    <svg v-if="cId == 'CACHE'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-c-square" viewBox="0 0 16 16">
                                      <title>{{ cId }}</title>
                                      <path d="M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"/>
                                      <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"/>
                                    </svg>
                                    <svg v-else-if="cId.startsWith('Tape')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cassette-fill" viewBox="0 0 16 16">
                                      <title>{{ cId }}</title>
                                      <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"/>
                                      <path d="m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"/>
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hdd-fill" viewBox="0 0 16 16">
                                      <title>{{ cId }}</title>
                                      <path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>
                                    </svg>
                                  </div>
                                </template>
                                <img v-if="file.location_info != undefined && Object.keys(file.location_info).includes('alto')" title="ALTO" :src="altoLogo" alt="alto"/>
                              </div>
                            </div>
                            <div v-if="eOMenu ||!['GROWING'].includes(file.state)" 
                              :class="eOMenu?'overWriteShortcutIconWrapper':''" class="shortcut-actions-type-icons-wrapper" style="z-index:2;">
                              <template v-if="!['MARK FOR DELETE'].includes(file.state) &&
                                              !['no-access','browse'].includes(file.permissions) &&
                                              (Object.keys(selectedFileInfo).length >= 1 || Object.keys(selectedFiles).length == 1 ||
                                                Object.keys(selectedFileInfo).length <= 0 && Object.keys(selectedFiles).length <= 0 ||
                                                  !isFileSelected(file))">
                                <svg v-if="!lockRestrictedAction('Download',file) && isFileActionEnabled('Download', file.permissions)" @click="handleDownloadAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-download" viewBox="0 0 16 16">
                                  <title>{{$t('Download')}}</title>
                                  <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                  <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                </svg>
                                <svg v-if="!lockRestrictedAction('Share',file) && isFileActionEnabled('Share',file.permissions)" @click="handleShareAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-share-fill" viewBox="0 0 16 16">
                                  <title>{{$t('Share')}}</title>
                                  <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                                </svg>
                                <svg v-if="(!lockRestrictedAction('tag-metadata',file) || !lockRestrictedAction('tag-metadata-requestor',file)) && (isFileActionEnabled('tag-metadata',file.permissions) || isFileActionEnabled('tag-metadata-requestor', file.permissions))" @click="handleTagMetadataAssetHoverAction(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-tag-fill" viewBox="0 0 16 16">
                                  <title>{{$t('Tag Metadata')}}</title>
                                  <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                                </svg>
                              </template>
                              <svg v-if="!lockRestrictedAction('Preview',file)" @click="showAssetDetails(file)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#928f8f">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <title>{{$t('Preview')}}</title>
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                              </svg>
                              <div class="overflow-parent-div">
                                <svg @click="eOMenu=true;selectElement($event,file,false);show($event, selectedFileInfo)" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                  <title>{{$t('More actions')}}</title>
                                  <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                </svg>
                                <!-- <svg @click="eOMenu=!eOMenu" width="16" height="16" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="#a3adad" xmlns="http://www.w3.org/2000/svg">
                                  <title>More actions</title>
                                  <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                                </svg>
                                <div v-if="eOMenu" class="dropdown-menu dropdown-menu-md-right p-0 overflow-menu"  aria-labelledby="bd-versions">
                                      <div class="dropdown-item p-2 copy-link-action" @click="setClipBoardText(file)" title="Copy link">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fdfff4" class="bi bi-link-45deg" viewBox="0 0 16 16">
                                            <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
                                            <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
                                        </svg>
                                        Copy link</div>
                                      <div v-if="isEnabled('Chat')" class="dropdown-item p-2 copy-link-action" @click="openShareInChat()" title="">
                                        <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#928f8f" class="bi bi-share-fill" viewBox="0 0 16 16">
                                          <title></title>
                                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
                                        </svg>
                                        Share in chat</div>
                                </div> -->
                              </div>
                            </div>
                          </div>
                          <img
                            v-if="file.state == 'GROWING'"
                            :src="growingFileGif"
                            alt="loading"
                            style="height:50px;width:65px;position:absolute;bottom:23%;inset-inline-start:19%"
                          />
                          <svg v-else-if="file.state == 'ERROR'" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#af0000" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16" style="position:absolute;bottom:35%;inset-inline-start:39%">
                              <title>ERROR</title>
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                          </svg>
                          <img
                            v-else-if="file.state == 'MARK FOR DELETE'"
                            :src="markForDeleteIcn"
                            alt="markfordelete"
                            style="height:20px;width:20px;position:absolute;bottom:42%;inset-inline-start:41%"
                          />
                        </div>
                      </td>
                      <td
                        style="text-align: start;position: relative;padding: 15px;vertical-align: middle;"
                        >
                        <!-- <div
                          v-html="getSvgIconsOfMediaTypes(file)"
                          class="svg-icons-display"
                          style="display:inline-table"
                        ></div>
                        <span :title="getDisplayFN(file)" class="file-name-display-styles-in-list-view" v-if="!getHighlightFilename(file,file.slug_name).highlight">
                          {{ getDisplayFN(file) }}
                        </span>
                        <span :title="getDisplayFN(file)" class="file-name-display-styles-in-list-view" v-else v-html="getHighlightFilename(file,file.slug_name).slugname">
                          {{ getDisplayFN(file) }}
                        </span> -->

                         <div style="display:flex">
                              <div v-html="getSvgIconsOfMediaTypes(file)" class="svg-icons-display" style="display:inline-table"></div>
                              <span class="file-name-display-styles-in-list-view" :title="getDisplayFN(file)" v-if="!getHighlightFilename(file,file.slug_name).highlight">{{ getFileName(file, true) }}
                                <span class="file-extension" v-if="globalSettingsFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
                              </span>  
                              <span class="file-name-display-styles-in-list-view" :title="getDisplayFN(file)" v-else style="display: flex;margin-inline-start: 20px;">
                                <span class="dynamic-slug-name" v-html="getHighlightFilename(file,file.slug_name).slugname"></span>
                                <span class="file-extension" v-if="globalSettingsFromStartup.enable_file_extension && file.mime_type" :title="file.mime_type.split('/')[1]">.{{file.mime_type.split('/')[1]}}</span>
                              </span>
                          </div>
                          <div style="margin-top: 9px;">
                          <div v-if="file.ttl" class="d-flex dull-the-text" style="position: relative;inset-inline-start:0px;display:flex;font-size:12px;flex-wrap:wrap;bottom: 4px;inset-inline-start :-6px;">
                            <template v-if="calculateLeftOverTTLDays(file.ttl) >= 0">{{$t('Expires on')}}:</template>
                            <template v-else>{{$t('Expired on')}}:</template>
                            <span style="color:#aaa"> &nbsp; {{file.ttl.split('T')[0]}} ({{calculateLeftOverTTLDays(file.ttl)}} 
                              <template v-if="[-1,1].includes(calculateLeftOverTTLDays(file.ttl))">{{$t('day')}})</template>
                              <template v-else>{{$t('days')}})</template>
                            </span>
                          </div>
                          <div style="position: relative; inset-inline-start :-8px; display: flex; flex-wrap: wrap;">
                            <template v-if="file.label_info && file.label_info.length">
                              <span class="display-label mr-1 mb-1" v-for="label in file.label_info" :key="label.label_id" :style="label.label_type == 'user_defined'?applyBorder(label):applyBackground(label)">
                                <template v-if="label.name">{{label.name}}</template>
                                <template v-else>None</template>
                              </span>
                            </template>
                          </div>
                        </div>
                      </td>
                      <td style="padding:15px; vertical-align: middle"
                        v-show="
                          !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                        "
                        :title="getDateAndTimeInConfiguredFormat(file.created_datetime)"
                        >
                        {{ getDateAndTimeInConfiguredFormat(file.created_datetime, true) }}
                      </td>
                      <td
                        style='vertical-align: middle'
                        v-show="
                          !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                        "
                        :title="getDateAndTimeInConfiguredFormat(file.added_datetime)"
                      >
                        {{ getDateAndTimeInConfiguredFormat(file.added_datetime, true) }}
                      </td>
                      <td
                        style="text-align:end;padding:15px;vertical-align: middle"
                        v-show="
                          !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                        "
                        :title='humaniseSize(file)'
                      >
                        {{humaniseSize(file)}}
                      </td>
                      <!-- <td
                        style="text-align:center"
                        v-if="
                          !getIsMetadataDockVisible && !getIsAssetsDetailsPanelVisible
                        "
                      >
                        {{ getMimeType(file.mime_type) }}
                      </td> -->
                    </tr>
                    <tr :key="file._id" style="height: unset;">
                        <td></td>
                        <td>
                            <div class="keyword-highlight-wrapper" v-html="getMatchedDetailsHighlight(file)">
                                
                            </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr> 
                  </template>
                </drag-select-container>
                </template>
              </template>
          </tbody>
        </table>
      </div>
      <div style="display: inline-flex;width:100%">
        <div style="width:50%;display:inline-flex;">
          <div v-for="(value,opkey) of getSelectedAssetsCount()" :key="opkey" style="display: inline-flex;;margin-inline-end: 15px;width:100%">
            <div style="color:#777777;padding-inline-end: 3px;margin-inline-start:12px">{{opkey}} :</div>
            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 80%;text-align: start;" :title="value">{{value}}</div>
          </div>
        </div>
        <div style="width:50%">
          <pagination
            v-if="totalFiles > -1"
            v-model="page"
            :records="totalFiles"
            :per-page="perPage"
            @paginate="paginate"
            :options="options"
          />
        </div>
      </div>
      <v-menu 
          v-model="showShareSubmenu"
          :position-x="submenuX"
          :position-y="submenuY"
          absolute
          offset-y
          >
          <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
            v-for="item in contextMenuShareOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles),{boundComponent: getComponent})
            "
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
          </v-list>
      </v-menu>
      <v-menu 
          v-model="showAIToolsSubmenu"
          :position-x="submenuX"
          :position-y="submenuY"
          absolute
          offset-y
          >
          <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
            v-for="item in contextMenuAIToolOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles),{boundComponent: getComponent})
            "
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
          </v-list>
      </v-menu>
      <v-menu 
        v-model="showArchiveToSubMenu"
        :position-x="submenuX"
        :position-y="submenuY"
        absolute
        offset-y
        >
        <v-list>
          <v-list-item
            v-for="item in contextMenuArchiveOptions"
            :key="item.pool_id"
            @click="archiveto(item.pool_id)"
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="getTargetBinIcon"></div>
              <div style="padding-inline-start:7px;">{{ getPoolLabel(item) }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu 
        v-model="showOpenWithToolSubmenu"
        :position-x="submenuX"
        :position-y="submenuY"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
              v-for="item in contextMenuOpenWithOptions"
              :key="item._id"
              @click=" getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo) , {boundComponent: getComponent})"
              >
            <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
              <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>
      <v-menu 
        v-model="showRetrieveFromSubmenu"
        :position-x="submenuX"
        :position-y="submenuY"
        absolute
        offset-y
        >
        <v-list>
          <v-list-item
            v-for="item in contextMenuRetrieveOptions"
            :key="item.pool_id"
            @click="retrieveFrom(item.pool_id)"
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="getTargetBinIcon"></div>
              <div style="padding-inline-start:7px;">{{ getPoolLabel(item) }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-model="showMoreSubMenu"
        :position-x="submenuX"
        :position-y="submenuY"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuMoreOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),  Object.assign({},selectedFiles),{boundComponent: getComponent})
            "
            >
            <v-list-item-title class="d-inline-flex">
              <div v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>

          <!-- ------removed hardcodede Hype Share option -->
          <!-- <v-list-item
              v-if="Object.keys(selectedFileInfo).length != 0 && selectedFileInfo.asset_state == 'READY' && isEnabled('Hype-SocialMedia')"
              @click="editAndShareAction()"
          >
            <v-list-item-title class="d-inline-flex">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-hand-thumbs-up-fill" viewBox="0 0 16 16">
                  <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>
                </svg>
              </div>
              <div style="padding-inline-start:7px;">Hype share</div>
            </v-list-item-title>
          </v-list-item> -->
          
        </v-list>
      </v-menu>
      <v-menu 
        v-model="showExportSubMenu"
        :position-x="submenuX"
        :position-y="submenuY"
        absolute
        offset-y
        >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuExportOptions"
            :key="item._id"
            @click="getExportEventHandler(item, $event)"
            >
            <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
              <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
            <v-list-item-title v-else class="d-inline-flex">
              <div v-html="getTargetBinIcon"></div>
              <div style="padding-inline-start:7px;">{{$t('to')}} {{ item.bin_id }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu 
          v-model="showExportProxySubMenu"
          :position-x="submenuX"
          :position-y="submenuY"
          absolute
          offset-y
          >
          <v-list :class="eOMenu?'vmenuOnHover':''">
            <v-list-item
              v-for="(item,index) in contextMenuExportProxyOptions"
              :key="item._id+index"
              @click="getExportProxyEventHandler(item, $event)"
              >
            <v-list-item-title v-if="'action_name' in item" class="d-inline-flex">
              <div  style="position:relative" v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
              <v-list-item-title v-else class="d-inline-flex">
                <div v-html="getTargetBinIcon"></div>
                <div style="padding-inline-start:7px;">to {{ item.bin_id }}</div>
              </v-list-item-title>
            </v-list-item>
          </v-list>
      </v-menu>
      <v-menu
        v-model="showNewSubMenu"
        :position-x="submenuNewX"
        :position-y="submenuNewY"
        absolute
        offset-y
      >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuNewOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),{boundComponent: getComponent})
            "
          >
            <v-list-item-title class="d-inline-flex">
              <div v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-model="showImportSubMenu"
        :position-x="submenuImportX"
        :position-y="submenuImportY"
        absolute
        offset-y
      >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuImportOptions"
            :key="item._id"
            @click="
              getEventHandler(
                item,
                'onClick',
                item.onEvents
              )($event, Object.assign({},selectedFileInfo),{boundComponent: getComponent})
            "
          >
            <v-list-item-title class="d-inline-flex">
              <div v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
      >
        <v-list :class="eOMenu?'vmenuOnHover':''">
          <v-list-item
            v-for="item in contextMenuOptions"
            :key="item._id"
            @mouseenter="showSubmenu(item, $event)"
            @click="getEventHandler(item, 'onClick', item.onEvents)($event,Object.assign({},selectedFiles),{boundComponent: getComponent})"
          >
            <v-list-item-title class="d-inline-flex">
              <div v-html="item.iconSvgCallback(item.label)"></div>
              <div style="padding-inline-start:7px;">{{ $t(item.label) }}</div>
              <svg v-if="item.sub_menu != undefined && item.sub_menu != 'DEFAULT'" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;fill: #c5c5c5;">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="Object.keys(selectedFileInfo).length != 0" @mouseenter="preventSubMenuDisplay()"
            @click="openProperties()"
          >
            <v-list-item-title class="d-inline-flex">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
              </svg>
              </div>
              <div style="padding-inline-start:7px;">{{$t('Properties')}}</div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import TopNav from "../core/Topnavigation.vue";
import { mapMutations, mapActions, mapGetters } from "vuex";
import Utils from "../../components.utils.js";
import {NotifierConstants} from "../../components.constants.js";
import Pagination from "vue-pagination-2";
import { BinContextMenu } from "../../registry/plugins.js";
import Constants from "../../components.constants.js";
import DragSelect from "drag-select-vue"
import highlightMixin from '../../mixins/highlightMixin.js';
import renameFolder from "../actions/RenameFolder.vue"
import createFolder from "../actions/CreateFolder.vue"
// import MetadataRequestor from "./MetadataRequestor.vue"
import EditAndShare from "../share/EditAndShare.vue";
import modifyTTL from "../actions/ModifyTTL.vue";
//import ManageVersion from "../ManageVersions/ManageVersionsDialog.vue";
import StoryBoardImagePreview from '../core/StoryboardOnThumbnail.vue';
import CatalogsBinsCommonMixins from '../../mixins/CatalogsBinsCommonMixin.js';
import RetrieveAs from "../core/RetrieveAs.vue";
import ManageAssetsLink from "../AssetsLinks/AssetsLinkViewOrEdit.vue";
import setLabelToAssetDialog from "./SetLabelDialog.vue";
import "../../../src/assets/common.scss"
import customAlertMessage from "../actions/customAlertMessage.vue";

export default {
  mixins:[highlightMixin,CatalogsBinsCommonMixins],
  components: {
    "top-nav": TopNav,
    'drag-select-container': DragSelect,
    pagination: Pagination,
    "rename-folder": renameFolder,
    "create-folder":createFolder,
    // "metadata-requestor":MetadataRequestor,
    // "new-tasks-issues":NewTasksIssues,
    "edit-and-share":EditAndShare,
    "modify-ttl": modifyTTL,
    //"manage-version":ManageVersion,
    StoryBoardImagePreview,
    "retrieve-as":RetrieveAs,
    "manage-assets-link": ManageAssetsLink,
    "set-label-to-asset":setLabelToAssetDialog,
    customAlertMessage
  },
  computed: {
    contextMenuShareOptions() {
      return this.subMenuShareItems;
    },
    contextMenuAIToolOptions(){
      return this.subMenuAIToolItems;
    },
    selectedFilesDetails(){
      return {"singlefile":this.selectedFileInfo, "multiplefiles":this.selectedFiles}
    },
    dirs() {
      let traverPathList = this.getFoldersList()
      return traverPathList;
    },
    contextMenuOptions() {
      let contextMenuOptions = this.contextMenuItems;
      return contextMenuOptions.sort(function(a, b){return a.position_priority - b.position_priority})
    },
    contextMenuMoreOptions() {
      let moreContextMenuOptions = this.subMenuItems;
      return moreContextMenuOptions.sort(function(a, b){return a.position_priority - b.position_priority})
    },
    contextMenuExportOptions() {
      return this.subMenuExportItems;
    },
    contextMenuOpenWithOptions(){
      return this.subMenuOpenWithItems;
    },
    contextMenuExportProxyOptions(){
      return this.subMenuExportProxyItems;
    },
    contextMenuArchiveOptions(){
        return this.subMenuArchiveItems;
    },
    contextMenuRetrieveOptions(){
        return this.subMenuRetrieveItems;
    },
    getTargetBinIcon(){
      return Utils.getBinsSvg("",16,16);
    },
    contextMenuNewOptions() {
      return this.subMenuNewItems;
    },
    contextMenuImportOptions() {
      return this.subMenuImportItems;
    },
    getDefaultPoolfromInMem(){
        for (const pool of Object.values(this.getPoolsfromInMem())) {
            if (pool.default){
                return pool
            }
        }
        if (Object.values(this.getPoolsfromInMem()).length){
            return Object.values(this.getPoolsfromInMem())[0]
        }
        return {}
    },
    globalSettingsFromStartup:{
        get(){
            return this.$store.state.startUpData.startUpDataDetails;
        }
    },
    ...mapGetters("users", [
      "getisMiniplayerVisible",
      "getIsMetadataDockVisible",
      "getIsAssetsDetailsPanelVisible",
      "getLoggedInUserAccessControl",
      "getLoggedInUserPrivilege",
      "getLoggedInUserType",
      "getLoggedInUserId"
    ]),
    // ...mapGetters("pools", ["getDefaultPoolfromInMem"]),
    ...mapGetters("privileges", ["getActionListFromInMem"]),
    ...mapGetters("actions", ["getPasteActionInfoFromInMem"]),
    ...mapGetters("bins", ["getSelectedPath"]),
    ...mapGetters("files",["getfolderInfoToGetCurrentPath","getAdvanceSearchData"]),
    ...mapGetters("download",["getDownloadFilesArr"]),
    currentProperties() {
      if(this.openTagMetadataModel == "set-label-to-asset"){
        let properties = {}
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          properties['seletedAssetIdList'] = [this.selectedFileInfo.asset_id];
          properties['selectedAssetInfo'] = this.selectedFileInfo
        }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          properties['seletedAssetIdList'] = Object.values(this.selectedFiles).map(obj => obj.asset_id);
          properties['selectedAssetInfo'] = null
        }
        return  properties
      }else if (
        ["retrieve-as","metadata-manager","rename-folder", "properties","metadata-requestor","edit-and-share"].includes(this.openTagMetadataModel) || this.openSubclips
      ) {
        return { fileInfo: this.selectedFileInfo , context:"bins"};
      } else if (this.openTagMetadataModel === "external-plugin-manager") {
        return { pluginInfo: this.selectedExternalPluginInfo,fileInfo: {"singlefile":this.selectedFileInfo, "multiplefiles":this.selectedFiles}};
      }else if(this.openTagMetadataModel === 'PartialRetrieve' || this.openTagMetadataModel == 'new-review' || this.openTagMetadataModel == 'manage-version'){
          if(Object.keys(this.selectedFileInfo).length) return { fileInfo : this.selectedFileInfo,newReview:true}
          return { fileInfo : this.selectedFiles,newReview:true}
      }
      // else if(this.openTagMetadataModel == 'new-tasks-issues'){
      //    console.log("checking****************************BinsNewTask");
      //    if(Object.keys(this.selectedFileInfo).length) return { fileInfo : this.selectedFileInfo, newTaskIssue:true}
      //     return { fileInfo : this.selectedFiles, newTaskIssue:true }
      // }

      else if(["bulk-tagmetadata-manager","OCR","OBD","facedetection","AudioTranscript","VideoTranscript","share-with-user","share-via-email"].includes(this.openTagMetadataModel) || this.openVideoTranscript){
        if(Object.keys(this.selectedFileInfo).length){
          return { filesInfo : [this.selectedFileInfo], updateType:"asset_list", fileInfo:this.selectedFileInfo}
        }
        return { filesInfo : this.getSelectedMultipleFilesAsList(this.selectedFiles), updateType:"asset_list"}
      }
      else if(this.openTagMetadataModel == "modify-ttl"){
        if(Object.keys(this.selectedFileInfo).length){  
          return { filesInfo : [this.selectedFileInfo], context:"bins"} 
        } 
        return { filesInfo : this.getSelectedMultipleFilesAsList(this.selectedFiles), context:"bins"}            
      }else if(this.openTagMetadataModel == "manage-assets-link"){
        if(Object.keys(this.selectedFileInfo).length){
          return {fileInfo:this.selectedFileInfo, viewOnly:false}
        }
        return {fileInfo:null}
      }
      else {
        return {fileInfo: this.selectedFileInfo};
      }
    },
    folderInfoToGetCurrentPath() {
      this.currentPath();
      return this.currentPathInfo;
    },
    alertMessageProperties(){
      return {
        "messageTitle":this.$t("Access Denied"),
        "messageType": "",
        "displayMessage":`${this.$t("You do not have the required privileges to access this feature. Please reach out to your administrator for assistance")}.`,
        "getUserConfirmation":false}
    },
  },
  watch:{
   immediate:true,
   deep:true,

    openTagMetadataModel(newVal,oldVal){
      console.log("Watcher : openTagMetadataModel ",typeof(oldVal))
      if(newVal){
        this.closeContextMenu()
      }
    },
    currentFolderInfo(){
      this.currentPath();
    },
    // searchKeyword(newVal, oldVal){
    //   if (newVal != oldVal){
    //     this.refreshFilesList(this.currentFolderInfo);
    //   }
    // },
    isAdvancedSearchEnabled(newVal){
      if(newVal == false){
        this.advanceSearchKeys = {};
        // this.refreshFilesList(this.selectedCatalog);
      }
    },
    "$route" : function(newVal, oldVal){
      if (newVal.fullPath != oldVal.fullPath){
        this.eventsAttached = false;
        try{
            let modalComponentList = ['modal_component','asset_modal_component','tag_modal_component','catalog_modal_component'];
            let routeNamesList = ['share','file-object-detection'];
            if(oldVal.meta && (modalComponentList.indexOf(oldVal.meta.componentType) > -1 || routeNamesList.indexOf(oldVal.name) > -1)){
                  this.lastClosedDialogMap.modalName = oldVal.name;
                  this.lastClosedDialogMap.isAssetUnselectRequired = this.determineUnselectOfAssets(oldVal);
            }
          }catch(e){console.log(e)}
        if (this.$route.name == "bins-browse") {
          this.handleBrowse()
        }else if (this.$route.matched[this.$route.matched.length-1].parent.name == "bins-browse" && 
                   this.$route.matched[this.$route.matched.length-1].parent.name != undefined &&
                   this.$route.meta.componentType != "bin_modal_component"){
          this.handleBrowseComponent()
        }
      }
    },
  },
  methods: {
    getComponent(){
      return this;
    },
    lockRestrictedAction(actionName,fileInfo){
      return Utils.lockRestrictedAction(fileInfo, actionName, this.getActionListFromInMem, this.globalSettingsFromStartup)
    },
    applyBorder(label){
      if(label && label.color){
        return {'border':'2px solid'+label.color+'!important','color':label.color}
      }
      return {'border':'2px solid #363636 !important','color':'EEE !important'}
    },
    applyBackground(label){
      if(label && label.color){
        return {'background':label.color+'!important','color':Utils.textColor(label.color)}
      }
      return {'background':'#363636 !important','color':Utils.textColor('EEE')}
    },
    changeJobsPanelState(state){
      this.$emit('changeJobsPanelState',state)
    },
    getColorBasedOnExpiry(locationInfo){
      if(Object.keys(locationInfo).includes('aws') && Object.keys(locationInfo.aws).includes('restoration_expiry_datetime')){
        let currentDate = new Date();
        // Create the given date (replace with your desired date)
        let givenDate = new Date(locationInfo.aws.restoration_expiry_datetime);
        // Compare the dates
        if (currentDate > givenDate) {
          return 'currentColor'
        } else {
          return '#28a745'
        }
      }
      return 'currentColor'
    },
    getFileMimeType(file){
      return Utils.getFileMediaType(file);
    },
    traverseToAIComp(compName){
          if (compName == 'ai_ocr'){
            this.submitOCRAction();
          }else if(compName == 'ai_obd'){
            this.submitOBDAction();
          }else if(compName == 'ai_face_detection'){
            this.submitFaceDetectionAction();
          }else if(compName == 'ai_transcript'){
            this.submitTranscript();
          }
        },
    getFoldersList(){
      let traverPathList = []
      if(this.rootPathPermission){
        let paths = this.rootPathPermission.name_path;
        paths = paths.replace("share://","");
        let pathList = paths.split("/");
        let pathIds = this.rootPathPermission.path;
        pathIds = pathIds.replace("share_id://","");
        let pathIdList = pathIds.split("/");
        for(let i = 0; i<pathList.length;i++){
          traverPathList.push({
            _id:pathIdList[i],
            file_name:pathList[i],
            permissions:this.rootPathPermission.permission
          })
        }
      }
      this.folderStructure = traverPathList
      return traverPathList
    },
    setHeightOfTheTable(){
      if(this.$refs["top_nav_bar"] && this.$refs["top_nav_bar"].$el){
        let isTopNavBarVisible = this.$refs["top_nav_bar"].$el.clientHeight;
        if(isTopNavBarVisible){
          let heightCalc = isTopNavBarVisible + 50;
          return `height:calc(100% - ${heightCalc}px )`;
        }else{
          return `height:calc(100% - 100px)`;
        }
      }
      return `height:calc(100% - 100px)`;
    },
    loadTTLIcons(date){
      let timeNow = Math.floor(Date. now() / 1000);
      let ttlDateTime = new Date(date);
      ttlDateTime = Math.floor(ttlDateTime.getTime() / 1000);

      if(Math.floor((ttlDateTime - timeNow)/3600 <= 48 && (ttlDateTime - timeNow)/3600 >= 24)){
        return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#c7c700" class="bi bi-hourglass-split" viewBox="0 0 16 16">
                  <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                  <title>Expires in 2 days</title>
                </svg>`
      }else if(Math.floor((ttlDateTime - timeNow)/3600 <= 24 && (ttlDateTime - timeNow)/3600 >= 0)){
        return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#f16d06" class="bi bi-hourglass-split" viewBox="0 0 16 16">
                  <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                  <title>Expries in 1 day</title>
                </svg>`
      }else if(Math.floor((ttlDateTime - timeNow)/3600 < 0)){
        return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ff0000" class="bi bi-hourglass-bottom" viewBox="0 0 16 16">
                  <path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5zm2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702s.18.149.5.149.5-.15.5-.15v-.7c0-.701.478-1.236 1.011-1.492A3.5 3.5 0 0 0 11.5 3V2h-7z"/>
                  <title>Expired</title>
                </svg>`
      }else{
        return false;
      } 
    },
    selectAllFiles(event){
      if(event.target.checked){
        for(let i = 0; i< this.filesList.files.length; i++){
          // this.isFileSelected(this.filesList.files[i])
          this.multiSelectElemet(this.filesList.files[i]);
        }
      }else{
          this.unselectElement();
          this.unselectAllFiles();
          this.deselectFileAndContextMenu();
      }
    },
    replaceByDefaultImage(e,fileInfo,forsvgThumbnail = ''){
      e.target.onerror = null;
      if(fileInfo && fileInfo.mime_type && Utils.getMediaType(fileInfo.mime_type) == 'audio'){
            e.target.src = Utils.getAudioWaveformSvg();
            return;
       }
      try{
          if(forsvgThumbnail && forsvgThumbnail == 'FOR_SVG_THUMBNAIL'){
            let svgIcon = Utils.determineSvgIconForType(fileInfo);
            if(!svgIcon){ 
              e.target.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Utils.getDefaultUnknowIcon())}`;
            }else{
              e.target.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgIcon)}`
            }
            return;
          }
      }catch(err){console.log(err)}
      e.target.src = Utils.getNoThumbnailImg();
    },
    getPoolLabel(pool){
        return `${pool.pool_name}-(${pool.pool_owner})`
    },
    handleBrowseComponent(){
      this.routerComponentMapper[this.$route.name]()
    },
    getSelectedMultipleFilesAsList(files){
      let selectedFilesPathsList = [];
      if (files){
          for (let i of Object.keys(files)){
            selectedFilesPathsList.push(files[i])
          }
      }
      return selectedFilesPathsList;
    },
    openSubclipWindow(selectedAssetDetails){
      this.selectedFileInfo = selectedAssetDetails;
      this.openTagMetadataModel  = 'sub-clips-manager-as-child';
      this.$router.push({
        name:"sub-clips-manager-as-child",
        params:{assetId: selectedAssetDetails.asset_id, fileInfo:Object.assign({}, selectedAssetDetails),parentinfo:Object.assign({forceRedirect:true},this.$route)}
      })
      this.openSubclips = true;
    },
    openVideoTranscriptWindow(subclipInfo){
      console.log("ddddddddddddddddddddddddddddddddddddd",subclipInfo)
      this.selectedFileInfo = subclipInfo;
      this.openTagMetadataModel  = 'video-transcript-as-child';
      this.$router.push({
        name:"video-transcript-as-child",
        params:{assetId: this.selectedFileInfo._id, fileInfo:Object.assign({}, this.selectedFileInfo),parentinfo:Object.assign({forceRedirect:true},this.$route)}
      })
      this.openVideoTranscript = true;
    },
    sortBinsTable(option){
         this.sortBy = option;
         localStorage.setItem("bins_sort_by_value", JSON.stringify(option));
         this.refreshFilesList(this.currentFolderInfo);
    },
    updateFileStateFilter(statesArr){
      if(statesArr && Object.keys(statesArr).length){
        this.assetsState = statesArr;
      }else{
        this.assetsState = null;
      }
      this.refreshFilesList(this.currentFolderInfo);
    },
    downloadAssetsReport(){
      let assetIds = null;
      let isFolderSelected = false
      if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
        if(this.selectedFileInfo.file_type == "folder"){
          isFolderSelected = true
        }
        assetIds = JSON.stringify([this.selectedFileInfo.asset_id]);
      }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
        assetIds = JSON.stringify(Object.values(this.selectedFiles).map(obj => obj.asset_id));
        let folderList = Object.values(this.selectedFiles).map(obj => obj.file_type)
        if(folderList && folderList.includes('folder')){
          isFolderSelected = true
        }
      }
      if(isFolderSelected){
        alert("Files Reports is not yet supported for Folders. Please select valid files.")
      }else if(assetIds && assetIds.length > 0){
        this.downloadAssetsReportFromServer({params:{asset_id: assetIds}}).then((data)=>{
          if (Constants.acceptedStatusCodes.includes(data.statusCode)){
            this.$toast.info("You will be notified once the report is ready to download");
          }else{
            this.$toast.error(data.message);
          }
        })
      }else{
        alert("Please select valid files.")
      }
      this.unselectElement();
      this.unselectAllFiles();
      this.deselectFileAndContextMenu();
    },
    exportAssetstoOutbox(){
      let fileVersionIds = null;
      if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
        fileVersionIds = [this.selectedFileInfo.version_id];
      }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
        fileVersionIds = Object.values(this.selectedFiles).map(obj => obj.version_id);
      }if(fileVersionIds && fileVersionIds.length > 0){
        this.exportFilesToOutbox({params:{user_id:this.getLoggedInUserId}, add_file_version_ids:fileVersionIds}).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            if('message' in data){
              this.$toast.success(data.message);
            }else{
              this.$toast.success("Exported successfully")
            }
          } else {
              this.$toast.error(data.message);
          }
        })
      }else{
        alert("Please select valid files.")
      }
      this.unselectElement();
      this.unselectAllFiles();
      this.deselectFileAndContextMenu();
    },
    changeDir(fileInfo){
      this.unselectAllFiles();
      this.$router.push({
            name:"bins-browse", 
            params:{
              bin_id: this.binSelected,
              _id: fileInfo._id,
              file_name: this.getFileName(fileInfo),
              permissions: fileInfo.permissions,
              selectedBinId: this.binSelected,
              }
            }
            )
      this.$emit("clearSearchData");
      this.searchKeyword = null;
    },
    dragSelect(event){
      if (event.length<=1){
        return
      }
     if(event && event.length>= 1)
         this.unselectElement();
      let fileuidlist = [].concat(event)
      this.unselectAllFiles()
      for (const fileuid of fileuidlist) {
        let fileInfo = this.getFileInfoByfileuIdFromInMem(fileuid)
        if (Object.keys(fileInfo).length !=0){
          this.selectedFiles[fileInfo.file_uid] = fileInfo  ;
          this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles));
          this.dragSelected = true
        }
      }
    },
    currentPath(){
      this.currentPathInfo = {};
      let temp = this.currentFolderInfo
      if(this.rootPathPermission){
        temp["path"] = this.rootPathPermission.name_path
      }
      Object.assign(this.currentPathInfo, this.currentFolderInfo);
      this.currentPathInfo["folderInfo"] = this.currentFolderInfo;
      this.currentPathInfo["bin_id"] = this.selectedBinId;
      this.setfolderInfoToGetCurrentPath(this.currentPathInfo)
    },
    isFileSelected(fileInfo){
      if (fileInfo.file_uid in this.selectedFiles){
        return true
      }
      return this.isActive == fileInfo.file_uid
    },
    multiSelectElemet(fileInfo){
      if (this.selectedFiles[fileInfo.file_uid]){
          delete this.selectedFiles[fileInfo.file_uid]
          this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles));
          return true;
      }

      if (Object.keys(this.selectedFileInfo).length != 0){
        this.selectedFiles[fileInfo.file_uid] = fileInfo;
        this.selectedFiles[this.selectedFileInfo.file_uid] = this.selectedFileInfo;
      }
      
      // else{ 
        this.selectedFiles[fileInfo.file_uid] = fileInfo;
        this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles))
      // }
      if(Object.keys(this.selectedFiles) <= 1 && this.eOMenu){
        this.eOMenu = false;
      }
      if((Object.keys(this.selectedFiles) <= 1|| Object.keys(this.selectedFileInfo).length ) && this.eOMenu){
        this.eOMenu = false;
      }
    },
    closeSubmenu() {
      this.showMoreSubMenu = false;
      this.showNewSubMenu = false;
      this.showImportSubMenu = false;
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = false;
      this.showArchiveToSubMenu = false
      this.showOpenWithToolSubmenu=false;
      this.showRetrieveFromSubmenu = false;
      this.showShareSubmenu = false;
      this.showAIToolsSubmenu = false;
    },
    showSubmenu(item, event) {
      if (item.sub_menu != undefined && item.sub_menu != "DEFAULT") {
        this.getEventHandler(item, "onClick", item.onEvents, true)(event);
      } else {
        this.closeSubmenu();
      }
    },
    getDisplayFN(file){
      if (!('slug_name' in file) || !file.slug_name) {
        let fileName = file.file_name
        return fileName.substring(0, fileName.lastIndexOf("."));
      } else {
        return file.slug_name;
      }
    },
    isEnabled(priv) {
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
    },
    isFileActionEnabled(userAction, filePermission){
      let binFilesActionsList = this.getRegisteredBinsContextMenu();
      let indx = binFilesActionsList.findIndex(
        (op) =>
          (!this.isTrashPath() &&
          op.action_name == userAction &&
            (op.requiredPermissions.includes(filePermission)))
      );
      if(indx < 0){
        return false
      }else{
        return true
      }
    },
    format(date) {
      date = new Date(date);
      const day = `${date.getUTCDate()}`.padStart(2, "0");
      const month = `${date.getUTCMonth() + 1}`.padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    },
    changeComponent(compName) {
      this.$emit("clearSearchData");
      this.searchKeyword = null;
      this.unsetLocationHash();
      // Utils.unsetCookie('traverseHistory')
      this.$emit("changeSelectedMainComponent", compName);
    },
    changeModalComponent(compName) {
      // this.unsetLocationHash();
      // Utils.unsetCookie('traverseHistory')
      this.$emit("changeModalComponent", compName);
    },
    paginate(page) {
      this.deselectFileAndContextMenu(null, true);
      this.unselectElement();
      this.unselectAllFiles();
      this.currentPage = page;
      this.page = page
      this.totalPages= -1
      this.totalFiles= -1
      this.perPage= -1
      let query = Object.assign({},this.$route.query)
      query.page = this.currentPage
      this.$router.push({
        "query": query,
        "params":this.$route.params,
      })
      // this.handleBrowse()
    },
    formatedDate(date){
      return Utils.getDateFormat(date);
    },
    formatedDateandTime(date){
      return Utils.getDateAndTimeFormat(date)
    },
    determineUnselectOfAssets(routeObj){
       let routeName = String(routeObj.name).trim();
        let dontUnselectAssetsOnList = [
          'properties','metadata-manager','share-in-chat',
          'bulk-tagmetadata-manager','new-review','file-image-annotation-with-comment', 'file-object-detection'
        ];
        let subclipReg = /sub-clips-manager/igm;
        if(subclipReg.test(routeName)){
           return false;
        }
        let partialRetriveReg = /partial(-?)retrieve/igm;
        if(partialRetriveReg.test(routeName)){
          return false;
        }
        if(routeObj && dontUnselectAssetsOnList.indexOf(routeName) > -1){
           return false
        } 
        return true;
    },
    scrollToTheSelectedFile(){
      let selector = '', wrapper = '', fileInfo = {};
      if(Object.keys(this.selectedFileInfo).length){
         fileInfo = this.selectedFileInfo;
      }else if(Object.keys(this.selectedFiles).length >= 1){
        fileInfo = Object.values(this.selectedFiles)[0];
      }
      if(this.viewType) {
          selector = `li[attr="${fileInfo.file_uid}"]`;
          wrapper = '.assets-view-wrapper';
      }else{
         selector = `tr[attr="${fileInfo.file_uid}"]`;
          wrapper = '.list-view-wrapper';
      }
      try{
        if(!this.lastClosedDialogMap.isAssetUnselectRequired && Object.keys(fileInfo).length){
          setTimeout(() => {
              Utils.scrollToElement(document.querySelector(selector),document.querySelector(wrapper));
          },0);
        }
      }catch(e){console.log(e)}
      this.lastClosedDialogMap.isAssetUnselectRequired = true;
      return true;
    },
    closeModal() {
      this.isMetadataManagerVisible = false;
      if (!this.vdialogComponents.includes(this.openTagMetadataModel)){
          if(this.ModalParentRoute){
            this.lastClosedDialogMap.modalName = this.$route.name;
            this.lastClosedDialogMap.isAssetUnselectRequired = this.determineUnselectOfAssets(this.$route);
          }
        this.$router.replace({
          name:this.ModalParentRoute.name,
          params: this.ModalParentRoute.params,
          query: this.ModalParentRoute.query
        })
        this.ModalParentRoute = {}
      }
      this.openTagMetadataModel = null;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.openVideoTranscript = false;
    },
    closeSubclip(){
      this.openSubclips = false;
    },
    getMimeType(type) {
      let givenType = type.split("/")[0];
      if (givenType == "application") {
        givenType = "app";
      }
      return givenType;
    },
    openProperties() {
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"properties",
        params:{id:this.selectedFileInfo.file_uid, fileInfo:this.selectedFileInfo,parentinfo:this.$route}
      })
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "properties";
      // this.$parent.$refs.fadeWhenModelOpen.classList.value = this.$parent.$refs.fadeWhenModelOpen.classList.value + 'addOpacity'
    },
    // selectAssets(file){
    //   this.$emit("closePanels")
    //   if (!("isSelected" in file)){
    //       file.isSelected = true;
    //   }else {
    //       file.isSelected = !file.isSelected
    //       this.isActive = null
    //   }
    // },
    humaniseSize(file) {
      if(file.size){
        let data = Utils.humanizeSize(file.size);
        return `${data["value"]} ${data["unit"]}`;
      }else{
        return '-'
      }
    },
    getFileName(file, withOutExtention = false) {
      if (file.file_name && ![undefined, null].includes(file.file_name) && file.file_name.trim().length > 0) {
        if(withOutExtention){
          return (file.file_name.substring(0, file.file_name.lastIndexOf('.')) || file.file_name)
        }
        return file.file_name;
      } else if (file.dir_name && ![undefined, null].includes(file.dir_name) && file.dir_name.trim().length > 0) {
        return file.dir_name;
      } else {
        return Utils.getBaseName(file.path);
      }
    },
    submitPasteJob() {
      let aInfo = this.getPasteActionInfoFromInMem;
      let payload = {};
      let actionTypeCheck = `${aInfo.actionTypeCheck}`
      

      if (actionTypeCheck == "copy") {
        payload["job_name"] = "Copy";
      } else if (actionTypeCheck == "cut") {
        payload["job_name"] = "Move";
      }
      
      delete aInfo.actionTypeCheck
      
      for (const file_uid of Object.keys(aInfo)) {
        let actionInfo = aInfo[file_uid]
      
        payload["src_path"] = actionInfo.path;
        if (actionInfo.file_type === "file") {
          payload["element_type"] = "file";
        } else if (actionInfo.file_type === "folder") {
          payload["element_type"] = "folder";
        }
        if (typeof this.getPasteActionInfoFromInMem != "undefined" &&
          this.getPasteActionInfoFromInMem != null) {
          if (typeof this.currentFolderInfo == "undefined" || Object.keys(this.currentFolderInfo).length <= 0) {
            payload.dst_path = `${this.getSelectedPath}/`+ actionInfo.file_name;
          } else {
            payload.dst_path = this.currentFolderInfo.name_path + "/" + actionInfo.file_name;
          }
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
              this.unsetPasteActionsinfo();
            } else {
              this.$toast.error(data.message);
            }
          });
        }
      }
    },
    createPasteAction(fileInfo, type) {
      let events = [{
          event_name: "onClick",
          event_handler: this.submitPasteJob,
          handler_args: ["fileInfo"],
        },
      ];

      let pasteAction = new BinContextMenu("paste","Paste","Paste",Utils.getClipboardSvg,events,["full-control"],["READY"],"active",["files", "assets"],["file", "folder"],"ParentElement",null,"DEFAULT");
      pasteAction.register();
      fileInfo["actionTypeCheck"] = type;
      this.setPasteActionsinfo(fileInfo);
    },
    openURLinNewTab(event, fileInfo){
        let url = Utils.getPDFPATHFromFileInfo(fileInfo)
        console.log(`opening URL<${url}> in new tab for ${event} and `, fileInfo)
        window.open(url, "_blank");    
    },
    createViewPDFAction() {
      let events = [{
          event_name: "onClick",
          event_handler: this.openURLinNewTab,
          handler_args: ["fileInfo"],
        },
      ];

      let viewPDFAction = new BinContextMenu("viewpdf","View PDF","View PDF",Utils.getClipboardSvg,events,["full-control"],["READY"],"active",["files", "assets"],["file", "folder"],"SelfElement",null,"MOREACTIONS", false, false, ["doc"]);
      viewPDFAction.register();
    },
    // updateActionHolder(actionName){
    //   let actionHolder = {
    //     "job_name":actionName,
    //     "src_path": this.selectedFileInfo.path
    //   }
    //   if(this.selectedFileInfo.file_type === 'file'){
    //     actionHolder.element_type = "file"
    //   }else if(this.selectedFileInfo.file_type === 'folder'){
    //     actionHolder.element_type = "folder"
    //   }
    //   // this.setPasteActionsinfo(actionHolder)
    // },
    submitActionHolder() {
      if (
        typeof this.getPasteActionInfoFromInMem != "undefined" &&
        this.getPasteActionInfoFromInMem != null
      ) {
        let payload = this.getPasteActionInfoFromInMem;
        if (
          typeof this.currentFolderInfo == "undefined" ||
          Object.keys(this.currentFolderInfo).length <= 0
        ) {
          payload.dst_path = `share://${this.binSelected}/`;
        } else {
          payload.dst_path = this.currentFolderInfo.name_path + "/";
        }
        this.unsetPasteActionsinfo();
        this.createNewJob(payload).then((data) => {
          if (data.statusCode == 200) {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }
        });
      }
    },
    submitNewJob(actionName) {
      let payload = {
        job_name: actionName,
        path: this.selectedFileInfo.path,
      };
      if (this.selectedFileInfo.file_type === "file") {
        payload.element_type = "file";
      } else if (this.selectedFileInfo.file_type === "folder") {
        payload.element_type = "folder";
      }
      this.createNewJob(payload).then((data) => {
        if (data.statusCode == 200) {
          this.$toast.success(data.message);
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    selectElement(event, fileInfo, showInfo=true) {
      if (event != null) {
        event.stopImmediatePropagation();
      }
      this.unselectAllFiles()
      this.isActive = fileInfo.file_uid;
      this.selectedFileInfo = fileInfo;
      this.$emit("selectedSingleFile", Object.assign({},this.selectedFileInfo));
      if (fileInfo.file_type === "file" && showInfo) {
        let metadata = this.getIsMetadataDockVisible;
        let assetsInfo = this.getIsAssetsDetailsPanelVisible;
        let miniPlayer = this.getisMiniplayerVisible;

        if (metadata || assetsInfo || miniPlayer) {
          this.refreshFileInfoAndShowAsset(fileInfo.file_uid);
        }
      }
    },
    unselectElement() {
      this.isActive = null;
      this.selectedFileInfo = {};
      this.$emit("selectedSingleFile", Object.assign({},this.selectedFileInfo));
    },
    showAssetDetails(file, view) {
      this.closeContextMenu();
      this.selectElement(null, file);
      if (file.file_type === "file") {
        this.refreshFileInfoAndShowAsset(file.file_uid);
      } else {
        this.currentFolderInfo = {};
        Object.assign(this.currentFolderInfo, file);
        this.$router.push({
        name:"bins-browse", 
        params:{
          bin_id: file.bin_id,
          _id: file._id,
          file_name: this.getFileName(file),
          permissions: file.permissions,
          selectedBinId: file.bin_id,
          }
        }
        )

        this.setSelectedPath(file.path)
      }
      if (view == "list-view") {
        this.$emit("listViewVisible");
      }
      this.$emit("clearSearchData");
      this.searchKeyword = null;
    },
    isProxyPresent(file){
       if(typeof file.proxy_info == 'object' && file.proxy_info && file.proxy_info.thumbnail_uri) return true;
       return false;
    },
    isSubclipMarkersPresent(file){
      if(typeof file.markers == 'object' && file.markers && file.markers.frame_thumbnail_uri) return true;
       return false;
    },
    getThumbnailPath(file,forsvgThumbnail = '') {
      try{
        if(forsvgThumbnail && forsvgThumbnail == 'FOR_SVG_THUMBNAIL'){
            if(!this.isProxyPresent(file) && !this.isSubclipMarkersPresent(file)){
              let svgIcon = Utils.determineSvgIconForType(file);
              if(!svgIcon) return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Utils.getDefaultUnknowIcon())}`;
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgIcon)}`;
            }
        }
      }catch(err){console.log(err)}
      return Utils.getThumbnailPathfromFileInfo(file);
    },
    getHumanReadableDuration(duration){
      return Utils.getDurationInSeconds(duration)
    },
    is4K(fileWidth, fileHeight) {
      return fileWidth >= 3840 || fileHeight >= 3840
    },
    isFHD(fileWidth, fileHeight) {
      return fileWidth >= 1920 || fileHeight >= 1920
    },
    isHD(fileWidth, fileHeight) {
      return fileWidth >= 1280 || fileHeight >= 1280
    },
    isSD(fileWidth, fileHeight) {
      return fileWidth >= 720 || fileHeight >= 720
    },
    getReadableResolutionValue(file){
      let resKey = null
      let newClassName = null
      if('width' in file && 'height' in file){
        if(this.is4K(file.width, file.height)){
          newClassName = "res-fourK";
          resKey = "4K"
        }else if (this.isFHD(file.width, file.height)) {
          newClassName = "res-FHD"
          resKey = "FHD"
        }else if(this.isHD(file.width, file.height)){
          newClassName = "res-HD"
          resKey = "HD"
        }else if(this.isSD(file.width, file.height)){
          newClassName = "res-SD"
          resKey = "SD"
        }
        if(newClassName){
         this.$nextTick(()=>{
            let divId = "assetResolution_"+file["_id"];
            if(document.querySelector("#"+divId))document.querySelector("#"+divId).classList.add(newClassName)
          });
        }
      }
      if(!resKey && document.getElementById("assetResolution")){
        document.getElementById("assetResolution").remove()
      }
      return resKey
    },
    checkIfDisabled(file){
      if(file.mime_type && file.mime_type.startsWith('image')){
        if(this.getStartUpDataFromInCache() && this.getStartUpDataFromInCache().disable_resolution_display_for_image){
          return false;
        }
      }
      if(file.mime_type && file.mime_type.startsWith('video')){
        if(this.getStartUpDataFromInCache() && this.getStartUpDataFromInCache().disable_resolution_display_for_video){
          return false;
        }
      }
      return true;
    },
    fileExistsinMem(file_uid, file_info_list){
      let file_info = file_info_list.filter((file_)=>file_.file_uid==file_uid)
      if (file_info.length!=0){
        return true
      }
      return false
    },
    sortFoldersByDate(){
      this.filesList.dirs.sort((first, second)=>{
              let d1 = new Date(first.modified_datetime)
              let d2 = new Date(second.modified_datetime)
              return d2-d1;
            })
    },
    getSelectedAssetsCount(){
      let countInfo = {}
      if(Object.keys(this.selectedFileInfo).length){
        let opKey = "Selected File"
        let fVal = ""
        if(this.selectedFileInfo.file_type == 'folder'){
          opKey = "Selected Folder"
          fVal = this.selectedFileInfo["dir_name"]
        }else if('slug_name' in this.selectedFileInfo){
          fVal = this.selectedFileInfo.slug_name
        }else if('file_name' in this.selectedFileInfo){
          fVal = this.selectedFileInfo["file_name"]
        }
        countInfo[opKey] = "1 ("+ fVal + ")"
      }else if(Object.keys(this.selectedFiles).length){
        let fList = []
        let cList = []
        for(let obKey of Object.keys(this.selectedFiles)){
          let fInfo = this.selectedFiles[obKey]
          if(fInfo.file_type == 'folder'){
            cList.push(fInfo["dir_name"])
          }else if('slug_name' in fInfo){
            fList.push(fInfo.slug_name)
          }else if('file_name' in fInfo){
            fList.push(fInfo["file_name"])
          }
        }
        if(fList.length > 0){
          let opKey = "Selected File";
          if(fList.length > 1){
            opKey += "s"
          }
          countInfo[opKey] = fList.length
        }
        if(cList.length > 0){
          let opKey = "Selected Folder";
          if(cList.length > 1){
            opKey += "s"
          }
          countInfo[opKey] = cList.length
        }
      }
      return countInfo
    },
    sortfilesByDate(){
      this.filesList.files.sort((first, second)=>{
              let d1 = new Date(first.modified_datetime)
              let d2 = new Date(second.modified_datetime)
              return d2 - d1;
            })
    },
    addFolder(folder_info, sort_by_date=false){
      if (!(this.fileExistsinMem(folder_info, this.filesList.dirs))){
        this.filesList.dirs.push(folder_info);
        if (sort_by_date){
          this.sortFoldersByDate()
        }
        
      }
    },
    addFile(file_info,sort_by_date=false){
      if (!(this.fileExistsinMem(file_info, this.filesList.files))){
        this.filesList.files.push(file_info);
        if (sort_by_date){
          this.sortfilesByDate()
        }
      }
    },
    updateFolder(file, sort_by_date=false){
      let file_info = this.filesList.dirs.filter((file_)=>file_.file_uid==file.file_uid)
      if (file_info.length !=0){
        Object.assign(file_info[0], file)
        if (sort_by_date){
          this.sortFoldersByDate()
        }
      }
    },
    updateFile(file, sort_by_date=false){
      let file_info = this.filesList.files.filter((file_)=>file_.file_uid==file.file_uid)
      if (file_info.length !=0){
        if(!Object.hasOwnProperty.call(file,'permissions')) Object.assign(file,{permissions:this.currentFolderInfo.permissions});
        Object.assign(file_info[0], file);
        if (sort_by_date){
          this.sortfilesByDate()
        }
      }
    },
    removeFolder(file, sort_by_date=false){
      this.filesList.dirs = this.filesList.dirs.filter((file_)=>file_.file_uid!=file.file_uid)
      if (sort_by_date){
          this.sortFoldersByDate()
      }
    },
    removeFile(file, sort_by_date=false){
      this.filesList.files = this.filesList.files.filter((file_)=>file_.file_uid!=file.file_uid)
      if (sort_by_date){
          this.sortfilesByDate()
      }
      this.unselectElement()
    },
    addToFileList(file,sort_by_date=false){
      if (file.file_type === "folder") {
        this.addFolder(file,sort_by_date)
      } else {
        this.addFile(file,sort_by_date)
      }
    },
    updateFileList(file, sort_by_date=false){
      if (file.file_type === "folder") {
        this.updateFolder(file,sort_by_date)
      } else {
        this.updateFile(file,sort_by_date)
      }
    },
    removeFromFileList(file, sort_by_date=false){
      if (file.file_type === "folder") {
        this.removeFolder(file,sort_by_date)
      } else {
        this.removeFile(file,sort_by_date)
      }
    },
    // functionCallAfterSearchFieldsChange(searchQuery,keyword){
    //     this.advanceSearchKeys = searchQuery;
    //     this.searchKeyword = keyword;
    //     this.refreshFilesList(this.currentFolderInfo)
    // },
    // functionCallForGlobalKeywordSearch(keyword){
    //     this.searchKeyword = keyword;
    //     this.refreshFilesList(this.currentFolderInfo)
    // },
    refreshFilesList(fileInfo = {}) {
      this.isLoaded = false;
      let payload = { params: {} };
      payload.params.page = this.currentPage;

      payload.params.bin_id = `${this.binSelected}`;
      payload.params.browse = true;
      payload.params.sort_by= this.sortBy.sortOn;
      payload.params.sort_order= this.sortBy.ascDesc;
      payload.params.view_type = "list";

      if ((fileInfo != undefined || fileInfo != null) && Object.keys(fileInfo).length != 0) {
        if (fileInfo._id != this.binSelected) {
          payload.params._id = fileInfo._id;
          delete payload.params.bin_id
        }
        let alreadyInBin = false;
        for (let dir of this.folderStructure) {
          if (dir._id === fileInfo._id) {
            alreadyInBin = true;
          }
        }
        if (!alreadyInBin) {
          this.addFileinfoToFolderStructure({
            _id: fileInfo._id,
            file_name: this.getFileName(fileInfo),
            permissions: fileInfo.permissions,
          });
        }
      } else {
        this.setLocationHash({
          type: "bin-browse",
          _id: this.binSelected,
          file_name: this.binSelected,
          bin_id: this.binSelected,
        });
      }
      Utils.saveFolderHistory(this.folderStructure);

      // if (this.getfolderInfoToGetCurrentPath.folderInfo.parent_id_path != undefined){
      //   payload.params.parent_id_path = this.getfolderInfoToGetCurrentPath.folderInfo.parent_id_path + "/" +this.getfolderInfoToGetCurrentPath.folderInfo._id;
      // }else{
      //   payload.params.parent_id_path = "share_id://"+this.selectedBinId;
      // }

      if (this.searchKeyword && (this.searchKeyword != undefined || this.searchKeyword != null) && this.searchKeyword.length){
        payload.params.keyword = this.searchKeyword;
        delete payload.params.browse;
      }else{
        delete payload.params.keyword;
      }
      if(this.advanceSearchKeys != undefined && Object.keys(this.advanceSearchKeys).length){
          if('fields' in this.advanceSearchKeys && Object.keys(this.advanceSearchKeys.fields).length == 0){
              if(Object.keys(this.advanceSearchKeys).length > 1){
                payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
                delete payload.params.browse;
              }
          }else{
              payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
              delete payload.params.browse;
          }
        if(Object.keys(this.advanceSearchKeys).includes("fields") && Object.keys(this.advanceSearchKeys.fields).length == 0){
          delete payload.params.fields;
        }
      }
        
      let fileStateFromFilter = JSON.parse(localStorage.getItem('file-status-filter-state'));
      if(this.assetsState && this.assetsState.state && this.assetsState.state.length){
        payload.params.state = JSON.stringify(this.assetsState.state);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length){
        if(fileStateFromFilter.state && fileStateFromFilter.state.length){
          payload.params.state = JSON.stringify(fileStateFromFilter.state);
        }
      }else{
          delete payload.params.state;
      }

      if(this.assetsState && this.assetsState.filter && this.assetsState.filter.length > 0){
        if(typeof(fileStateFromFilter.filter) == 'string'){
          payload.params.filter = this.assetsState.filter;
        }else{
          payload.params.filter = JSON.stringify(this.assetsState.filter);
        }
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.filter && fileStateFromFilter.filter.length > 0){
          if(typeof(fileStateFromFilter.filter) == 'string'){
            payload.params.filter = fileStateFromFilter.filter;
          }else{
            payload.params.filter = JSON.stringify(fileStateFromFilter.filter);
          }
        }
      }else{
        delete payload.params.filter;
      }

      if(this.assetsState && this.assetsState.storage_class && this.assetsState.storage_class.length){
        payload.params.storage_class = JSON.stringify(this.assetsState.storage_class);
      }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
        if(fileStateFromFilter.storage_class && fileStateFromFilter.storage_class.length){
          payload.params.storage_class = JSON.stringify(fileStateFromFilter.storage_class);
        }
      }else{
        delete payload.params.storage_class;
      }

      try{ // Fix for DAM-1827
          let reg = /[0-9a-f]{8}[0-9a-f]{4}[0-9a-f]{4}[0-9a-f]{4}[0-9a-f]{12}/g;
          if(!payload.params.bin_id || payload.params.bin_id == 'null'){
              let resolvedObj = this.$router.resolve({path:window.location.pathname});
              if(resolvedObj && resolvedObj.resolved.params._id && !reg.test(resolvedObj.resolved.params._id)){
                  payload.params.bin_id = resolvedObj.resolved.params._id;
              }
          }
      }catch(e){console.log(e)}

      this.getAllFilesFromServer(payload).then((data) => {
        if (!Utils.isAcceptedStatusCode(data.statusCode)) {
          this.filesList = { dirs: [], files: [] };
          this.isLoaded = true;
          return;
        }
        //   this.filesList = data;
        this.totalPages = data["page_count"];
        this.currentPage = data["page"];
        this.page = data["page"]
        this.totalFiles = data["total_files"]?data["total_files"]:data["total_assets"];
        this.perPage = data["files_per_page"]?data["files_per_page"]:data["assets_per_page"];
        this.filesList = { dirs: [], files: [] };
        if("root_path_permissions" in data){
          this.rootPathPermission = data["root_path_permissions"];
          if(!this.binSelected){
            this.binSelected = Utils.getBinIdFromPath(this.rootPathPermission.name_path)
            this.$emit("updateActiveBinIdInWorkspace", this.binSelected)
          }
          if(this.currentFolderInfo){
            let idsList = this.rootPathPermission.path
            idsList = idsList.replace("share_id://","").split("/")
            if(idsList.length > 1){
              this.currentFolderInfo["_id"] = idsList[idsList.length-1] // current folder Id
            }
            this.currentFolderInfo["permissions"] = data["root_path_permissions"].permission
          }else{
            this.currentFolderInfo = this.folderStructure[this.folderStructure.length - 1]
          }
          this.currentPath()
          this.$emit("rootPathPermissionUpdated",this.rootPathPermission);
        }
        if(data["files"].length){
          this.setPermissionOfSelectedBin(data["files"][0].permissions)
        }
        for (let file of data["files"]) {
          this.addToFileList(file)
        }
        this.isLoaded = true;
        this.scrollToTheSelectedFile();
        
      });
    },
    totalAssetsDisplay(totalFiles){
      return Utils.displayTotalPageCountWithRange(totalFiles,this.perPage,this.currentPage);
    },
    changeToDirectoryFromUrl(fileInfo) {
      this.closeContextMenu();
      let binInfo = this.rootBins.find(op=>op.bin_id == fileInfo._id)
      if(binInfo){
        this.refreshFilesList({bin_id:fileInfo._id})
      }else{
        this.refreshFilesList({_id:fileInfo._id})
      }
      if(this.lastClosedDialogMap.isAssetUnselectRequired){
         this.unselectElement()
        //  this.lastClosedDialogMap.isAssetUnselectRequired = true;
      }
      // this.unselectElement();
    },
    initBrowse() {
      let fileInfo = {
        _id: this.binSelected,
        file_name: this.binSelected,
        permissions: "full-control",
      };
      this.addFileinfoToFolderStructure(fileInfo);
      this.refreshFilesList();
    },
    addFileinfoToFolderStructure(fileInfo){
      let file_found = this.folderStructure.filter((info)=>info._id==fileInfo._id)
      if (file_found.length ==0){
        this.folderStructure.push(fileInfo)
      }
    },
    updateFileStructureFromParentid(parent_id_path, parent_path, bin_id, permission){
      let parent_id_list = parent_id_path.replace("share_id://","").split("/")
      let parent_list = parent_path.replace("share://","").split("/")
      if (parent_id_list.length !=0){
        this.folderStructure = []
      }
      for (let i=0; i<parent_id_list.length; i++) {
        this.folderStructure.push(
          {
            bin_id: bin_id,
            file_name: parent_list[i],
            _id: parent_id_list[i],
            permissions: permission
          }
        )
      }
      Utils.saveFolderHistory(this.folderStructure)
    },
    async getFileInfoFromFolderStructure(_id){
      let file_found = this.folderStructure.filter((info)=>info._id==_id)
      if (file_found.length !=0){
        return Object.assign({},file_found[0])
      }else {
        let fileInfo = this.getFileInfoByfileuIdFromInMem(_id)
        if (Object.keys(fileInfo) == 0){
          try{
            let data = await this.getFileInfoFromServer({params: { fileId: _id }})
            fileInfo = data.file;
            this.selectedBinId = fileInfo.bin_id

            let folderdata = await this.getFolderStructureFromFileUID({params: { fileId: _id }})
            this.folderStructure = folderdata.folder_structure?folderdata.folder_structure:[]

            // this.updateFileStructureFromParentid(fileInfo.parent_id_path, fileInfo.parent_path, fileInfo.bin_id, fileInfo.permissions)
          }catch {
            return {}
          }
        }
        if (fileInfo){
          return fileInfo
        }
      }
      return {}
    },
    loadData(fileInfo={}) {
      this.closeContextMenu();
      if (this.isdestroyed) {
        return;
      }
      if (Object.keys(fileInfo).length != 0) {
        this.changeToDirectoryFromUrl(fileInfo);
      } else if (this.folderStructure.length == 1) {
        this.changeComponent("bins-display");
      } else {
        this.initBrowse();
      }
    
    },
    closeContextMenu() {
      this.eOMenu = false;
      this.showMenu = false;
      this.showMoreSubMenu = false;
      this.showNewSubMenu = false;
      this.showImportSubMenu = false;
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = false;
      this.showArchiveToSubMenu = false
      this.showOpenWithToolSubmenu=false;
      this.showRetrieveFromSubmenu = false
      this.showShareSubmenu = false
      this.showAIToolsSubmenu = false;
      this.x = 0;
      this.y = 0;
      this.submenuNewX = 0;
      this.submenuX = 0;
      this.submenuNewY = 0;
      this.submenuY = 0;
      this.contextMenuItems = [];
      this.subMenuItems = [];
      this.subMenuNewItems = [];
      this.subMenuExportItems = [];
      this.subMenuExportProxyItems =[];
    },
    unselectAllFiles(){
      this.selectedFiles = {};
      this.allFilesSelected = false;
      this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles));
      this.dragSelected = false
    },
    deselectFileAndContextMenu(event=null,hardReload=false) {
      // if clicked on contextmenu item then don't proceed further to diselect element
      if(this.$parent.$refs.globalButtonDropdown){
        this.$parent.$refs.globalButtonDropdown.classList.remove('show')
      }
      
      if(!event){
        return;
      }
      this.allFilesSelected = false;
      try{
        if(event && event.target && event.target.closest('.v-dialog__content.v-dialog__content--active')) return true;
      }catch(e){console.log(e)}
      try{
        if(event && event.target && event.target.closest('.modal')) return true;
      }catch(e){console.log(e)}
      try{
         if(event && event.target.closest('.v-list-item').getAttribute('role') == 'menuitem') return true;
      }catch(e){console.log(e)}
      if (hardReload){
        event = {ctrlKey: false}
      }
      if (this.dragSelected){
        this.dragSelected = false
        return
      }
      if (event){
        try{
          event.stopImmediatePropagation()
        }catch(error){
          console.log("error",error)
        }
        if (!(event.ctrlKey)){
          this.unselectAllFiles();
        }
      }
      this.allFilesSelected = false;
      this.closeContextMenu();
      this.unselectElement();
    },
    getLabelForAction(actionName) {
      let allPriv = [];
      for (let priv of Object.values(this.getPrivilegeFromInMem())) {
        Array.prototype.push.apply(allPriv, priv);
      }
      let label = allPriv.filter((action) => action.action_name == actionName);
      return label.length != 0 ? label[0].label : actionName;
    },
    triggerShowSubmenu(event) {
      if (this.showNewSubMenu) {
        this.showNewSubMenu = false;
      }
      if (this.showImportSubMenu) {
        this.showImportSubMenu = false;
      }
      if(this.showExportSubMenu){
        this.showExportSubMenu = false;
      }
      if(this.showExportProxySubMenu){
        this.showExportProxySubMenu = false;
      }
      if(this.showShareSubmenu){
        this.showShareSubmenu = false;
      }
      if(this.showAIToolsSubmenu){
        this.showAIToolsSubmenu = false;
      }
      this.showArchiveToSubMenu = false
      this.showOpenWithToolSubmenu=false;
      this.showRetrieveFromSubmenu = false
      let multiFiles = false
      if (Object.keys(this.selectedFiles).length != 0){
        multiFiles = true
      }
      this.showMoreSubMenu = !this.showMoreSubMenu;
      if(event.clientX > 900){
        this.submenuX = this.x - 190;
      }else{
        this.submenuX = this.x + 100;
      }
      if(event.layerY > 30){
        this.submenuY = event.clientY - 20;
      }else{
        this.submenuY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuItems = this.getContextMenuItems(
        this.selectedFileInfo,
        "MOREACTIONS",
        multiFiles
      );
      event.stopPropagation();
    },
    triggerShowExportSubmenu(event) {
      this.showShareSubmenu = false;
      if (this.showNewSubMenu) {
        this.showNewSubMenu = false;
      }
      if (this.showImportSubMenu) {
        this.showImportSubMenu = false;
      }
      if(this.showMoreSubMenu){
        this.showMoreSubMenu = false;
      }
      if(this.showAIToolsSubmenu){
        this.showAIToolsSubmenu = false;
      }
      this.showArchiveToSubMenu = false
      this.showOpenWithToolSubmenu=false;
      this.showRetrieveFromSubmenu = false
      this.showExportProxySubMenu = false;
      this.showExportSubMenu = !this.showExportSubMenu;
      if(event.clientX > 900){
        this.submenuX = this.x - 190;
      }else{
        this.submenuX = this.x + 100;
      }
      if(event.layerY > 30){
        this.submenuY = event.clientY - 20;
      }else{
        this.submenuY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuExportItems = []

      let fileTypes = [];
      let fileStates = [];
      if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
        for(let op of Object.keys(this.selectedFiles)){
          let fileInfo = this.selectedFiles[op]
          fileTypes.push(fileInfo.file_type);
          fileStates.push(fileInfo.state);
          if(fileInfo.file_type == "folder" || fileInfo.state == "GROWING"){
            break;
          }
        }
      }else if(this.selectedFileInfo != undefined && Object.keys(this.selectedFileInfo).includes('file_type')){
        fileTypes.push(this.selectedFileInfo.file_type)
        fileStates.push(this.selectedFileInfo.state)
      }
      if ((fileTypes.length > 0 && !fileTypes.includes("folder") && !fileStates.includes("GROWING") && !fileStates.includes("MARK FOR DELETE") &&
        this.deploymentBinsList != undefined &&
        this.deploymentBinsList.length > 0 && this.isEnabled("Export"))) {
        this.subMenuExportItems = this.subMenuExportItems.concat(this.deploymentBinsList)
      }
      let multiFiles = false
      if (Object.keys(this.selectedFiles).length != 0){
        multiFiles = true
      }
      let exportSubMenu = this.getContextMenuItems(
        this.selectedFileInfo,
        "EXPORTOPTION",
        multiFiles
      );
      if(exportSubMenu && exportSubMenu.length > 0){
        this.subMenuExportItems = this.subMenuExportItems.concat(exportSubMenu)
      }
      event.stopPropagation();
    },
    triggerShowExportProxySubmenu(event) {
      this.showShareSubmenu = false;
      if (this.showNewSubMenu) {
        this.showNewSubMenu = false;
      }
      if (this.showImportSubMenu) {
        this.showImportSubMenu = false;
      }
      if(this.showMoreSubMenu){
        this.showMoreSubMenu = false;
      }
      if(this.showAIToolsSubmenu){
        this.showAIToolsSubmenu = false;
      }
      this.showArchiveToSubMenu = false
      this.showOpenWithToolSubmenu=false;
      this.showRetrieveFromSubmenu = false
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = !this.showExportProxySubMenu;
      if(event.clientX > 900){
        this.submenuX = this.x - 190;
      }else{
        this.submenuX = this.x + 100;
      }
      if(event.layerY > 30){
        this.submenuY = event.clientY - 20;
      }else{
        this.submenuY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuExportProxyItems = []

      let fileTypes = [];
      let fileStates = [];
      if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
        for(let op of Object.keys(this.selectedFiles)){
          let fileInfo = this.selectedFiles[op]
          fileTypes.push(fileInfo.file_type);
          fileStates.push(fileInfo.state);
          if(fileInfo.file_type == "folder" || fileInfo.state == "GROWING"){
            break;
          }
        }
      }else if(this.selectedFileInfo != undefined && Object.keys(this.selectedFileInfo).includes('file_type')){
        fileTypes.push(this.selectedFileInfo.file_type)
        fileStates.push(this.selectedFileInfo.state)
      }
      if ((fileTypes.length > 0 && !fileTypes.includes("folder") && !fileStates.includes("GROWING") && !fileStates.includes("MARK FOR DELETE") &&
        this.deploymentBinsList != undefined &&
        this.deploymentBinsList.length > 0 && this.isEnabled("Export Proxy"))) {
        this.subMenuExportProxyItems = this.subMenuExportProxyItems.concat(this.deploymentBinsList)
      }
      let multiFiles = false
      if (Object.keys(this.selectedFiles).length != 0){
        multiFiles = true
      }
      let exportSubMenu = this.getContextMenuItems(
        this.selectedFileInfo,
        "EXPORTPROXYOPTION",
        multiFiles
      );
      if(exportSubMenu && exportSubMenu.length > 0){
        this.subMenuExportProxyItems = this.subMenuExportProxyItems.concat(exportSubMenu)
      }
      event.stopPropagation();
    },
    triggerShowSubmenuNew(event) {
      if (this.showMoreSubMenu) {
        this.showMoreSubMenu = false;
      }
      if(this.showExportSubMenu){
        this.showExportSubMenu = false;
      }
      if(this.showExportProxySubMenu){
        this.showExportProxySubMenu = false;
      }
      if(this.showShareSubmenu){
        this.showShareSubmenu = false;
      }
      if(this.showAIToolsSubmenu){
        this.showAIToolsSubmenu = false;
      }
      if (this.showImportSubMenu) {
        this.showImportSubMenu = false;
      }
      this.showArchiveToSubMenu = false
      this.showOpenWithToolSubmenu=false;
      this.showRetrieveFromSubmenu = false
      let multiFiles = false
      if (Object.keys(this.selectedFiles).length != 0){
        multiFiles = true
      }
      this.showNewSubMenu = !this.showNewSubMenu;
      if(event.clientX > 900){
        this.submenuNewX = this.x - 180;
      }else{
        this.submenuNewX = this.x + 90;
      }
      if(event.layerY > 30){
        this.submenuNewY = event.clientY - 20;
      }else{
        this.submenuNewY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuNewItems = this.getContextMenuItems(
        this.selectedFileInfo,
        "NEWOPTION",
        multiFiles
      );
      event.stopPropagation();
    },
    triggerShowSubmenuImport(event) {
      if (this.showMoreSubMenu) {
        this.showMoreSubMenu = false;
      }
      if (this.showNewSubMenu) {
        this.showNewSubMenu = false;
      }
      if(this.showExportSubMenu){
        this.showExportSubMenu = false;
      }
      if(this.showExportProxySubMenu){
        this.showExportProxySubMenu = false;
      }
      if(this.showShareSubmenu){
        this.showShareSubmenu = false;
      }
      if(this.showAIToolsSubmenu){
        this.showAIToolsSubmenu = false;
      }
      this.showArchiveToSubMenu = false
      this.showOpenWithToolSubmenu=false;
      this.showRetrieveFromSubmenu = false
      let multiFiles = false
      if (Object.keys(this.selectedFiles).length != 0){
        multiFiles = true
      }
      this.showImportSubMenu = !this.showImportSubMenu;
      if(event.clientX > 900){
        this.submenuImportX = this.x - 180;
      }else{
        this.submenuImportX = this.x + 90;
      }
      if(event.layerY > 30){
        this.submenuImportY = event.clientY - 20;
      }else{
        this.submenuImportY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuImportItems = this.getContextMenuItems(
        this.selectedFileInfo,
        "IMPORTOPTION",
        multiFiles
      );
      event.stopPropagation();
    },
    attachShareOption(contextMenuItems, multiFiles=false){
      let shareActions = this.getRegisteredShareContextMenu();
      let assetShareActions = this.getContextMenuItems(this.selectedFileInfo, "SHAREACTIONS", multiFiles);
      if(typeof shareActions == "undefined" || typeof assetShareActions == "undefined"){
        return
      }
      if (
        shareActions.length != 0 &&
        assetShareActions.length != 0
      ) {
        contextMenuItems.push({
          sub_menu: "SHAREACTIONS",
          label: "Share",
          iconSvgCallback:Utils.getShareSvg,
          onEvents: [
            {
              event_name: "onClick",
              event_handler: this.triggerShowShareSubmenu,
              handler_args: [],
            },
          ],
        });
      }
    },
    attachAIToolOption(contextMenuItems, multiFiles=false){
      let AIToolActions = this.getRegisteredAIToolsContextMenu();
      let assetAIToolActions = this.getContextMenuItems(this.selectedFileInfo, "AITOOLACTIONS", multiFiles);
      if(typeof AIToolActions == "undefined" || typeof assetAIToolActions == "undefined"){
        return
      }
      if (
        AIToolActions.length != 0 &&
        assetAIToolActions.length != 0
      ) {
        contextMenuItems.push({
          sub_menu: "AITOOLACTIONS",
          label: "AI Tools",
          iconSvgCallback:Utils.getAIToolsSvg,
          onEvents: [
            {
              event_name: "onClick",
              event_handler: this.triggerShowAIToolsSubmenu,
              handler_args: [],
            },
          ],
        });
      }
    },
    attachOpenWithToolOption(contextMenuItems, multiFiles=false){
      let opneWithActions = this.getRegisteresOpenWithContextMenu();
      let assetOpenWithActions = this.getContextMenuItems(this.selectedFileInfo, "OPENWITHACTIONS", multiFiles);
      if(typeof opneWithActions == "undefined" || typeof assetOpenWithActions == "undefined"){
        return
      }
      if (
        opneWithActions.length != 0 &&
        assetOpenWithActions.length != 0
      ) {
        contextMenuItems.push({
          sub_menu: "OPENWITHACTIONS",
          label: "Open in",
          iconSvgCallback:Utils.getOpenWithSvg,
          onEvents: [
            {
              event_name: "onClick",
              event_handler: this.triggerShowOpenWithoolsSubmenu,
              handler_args: [],
            },
          ],
        });
      }
    },
    triggerShowOpenWithoolsSubmenu(event){
      this.showArchiveToSubMenu = false
      this.showRetrieveFromSubmenu = false
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = false;
      if (this.showNewSubMenu) {
        this.showNewSubMenu = false;
      }
      if (this.showImportSubMenu) {
        this.showImportSubMenu = false;
      }
      if(this.showMoreSubMenu){
        this.showMoreSubMenu = false;
      }
      if(this.showShareSubmenu){
        this.showShareSubmenu = false;
      }
      if(this.showCatalogsIconSubmenu){
        this.showCatalogsIconSubmenu = false;
      }
      let multiFiles = false
      if (Object.keys(this.selectedFiles).length != 0){
        multiFiles = true
      }
      this.showAIToolsSubmenu = false;
      this.showOpenWithToolSubmenu = true;

      if(event.clientX > 900){
        this.submenuX = this.x - 190;
      }else{
        this.submenuX = this.x + 100;
      }
      if(event.layerY > 30){
        this.submenuY = event.clientY - 20;
      }else{
        this.submenuY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuOpenWithItems = this.getContextMenuItems(
        this.selectedFileInfo,
        "OPENWITHACTIONS",
        multiFiles
      );
      event.stopPropagation();
    },
    triggerShowAIToolsSubmenu(event){
      this.showOpenWithToolSubmenu=false;
      this.showArchiveToSubMenu = false
      this.showRetrieveFromSubmenu = false
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = false;
      if (this.showNewSubMenu) {
        this.showNewSubMenu = false;
      }
      if (this.showImportSubMenu) {
        this.showImportSubMenu = false;
      }
      if(this.showMoreSubMenu){
        this.showMoreSubMenu = false;
      }
      if(this.showShareSubmenu){
        this.showShareSubmenu = false;
      }
      let multiFiles = false
      if (Object.keys(this.selectedFiles).length != 0){
        multiFiles = true
      }
      this.showAIToolsSubmenu = true;

      if(event.clientX > 900){
        this.submenuX = this.x - 190;
      }else{
        this.submenuX = this.x + 100;
      }
      if(event.layerY > 30){
        this.submenuY = event.clientY - 20;
      }else{
        this.submenuY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuAIToolItems = this.getContextMenuItems(
        this.selectedFileInfo,
        "AITOOLACTIONS",
        multiFiles
      );
      event.stopPropagation();
    },
    triggerShowShareSubmenu(event) {
      this.showArchiveToSubMenu = false
      this.showRetrieveFromSubmenu = false
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = false;
      if (this.showNewSubMenu) {
        this.showNewSubMenu = false;
      }
      if (this.showImportSubMenu) {
        this.showImportSubMenu = false;
      }
      if(this.showMoreSubMenu){
        this.showMoreSubMenu = false;
      }
      if(this.showAIToolsSubmenu){
        this.showAIToolsSubmenu = false;
      }
      let multiFiles = false
      if (Object.keys(this.selectedFiles).length != 0){
        multiFiles = true
      }
      this.showShareSubmenu = !this.showShareSubmenu;

      if(event.clientX > 900){
        this.submenuX = this.x - 190;
      }else{
        this.submenuX = this.x + 100;
      }
      if(event.layerY > 30){
        this.submenuY = event.clientY - 20;
      }else{
        this.submenuY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuShareItems = this.getContextMenuItems(
        this.selectedFileInfo,
        "SHAREACTIONS",
        multiFiles
      );
      event.stopPropagation();
    },
    showViewPDFAction(fileInfo){
        try {
            if (Utils.getPDFPATHFromFileInfo(fileInfo)){
                return true
            }
        } catch (error) {
            console.error(`exception-->${error}`)
        }
        return false
    },
    triggerShowArchiveSubmenu(event){
      this.showMoreSubMenu = false;
      this.showNewSubMenu = false;
      this.showImportSubMenu = false;
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = false;
      this.showRetrieveFromSubmenu = false
      this.showShareSubmenu = false;
      this.showAIToolsSubmenu = false;
      
      this.showArchiveToSubMenu = !this.showArchiveToSubMenu

      if(event.clientX > 900){
        this.submenuX = this.x - 190;
      }else{
        this.submenuX = this.x + 100;
      }
      if(event.layerY > 30){
        this.submenuY = event.clientY - 20;
      }else{
        this.submenuY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuArchiveItems = []
      for (const pool of Object.values(this.getPoolsfromInMem()) ) {
          this.subMenuArchiveItems.push(pool)
      }
      
      event.stopPropagation();
    },
    triggerShowRetrieveSubmenu(event){
      this.showMoreSubMenu = false;
      this.showNewSubMenu = false;
      this.showImportSubMenu = false;
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = false;
      this.showArchiveToSubMenu = false;
      this.showShareSubmenu = false;
      this.showAIToolsSubmenu = false;
      
      this.showRetrieveFromSubmenu = !this.showRetrieveFromSubmenu

      if(event.clientX > 900){
        this.submenuX = this.x - 190;
      }else{
        this.submenuX = this.x + 100;
      }
      if(event.layerY > 30){
        this.submenuY = event.clientY - 20;
      }else{
        this.submenuY = event.clientY + 20;
      }
      // this.$nextTick(() => {
      //   this.showMenu = true
      // })
      this.subMenuRetrieveItems = []
      for (const pool of Object.values(this.getPoolsfromInMem()) ) {
          this.subMenuRetrieveItems.push(pool)
      }
      
      event.stopPropagation();
    },
    addArchiveToOption(contextMenuItems){
      let enableArchiveToUA = true
      if('ARCHIVE_TO_REQUIRED' in this.getStartUpDataFromInCache()){
        enableArchiveToUA = this.getStartUpDataFromInCache()['ARCHIVE_TO_REQUIRED'];
      }
      if(enableArchiveToUA){
        let hasArchivePrivilege = contextMenuItems.filter((item)=>item.action_name=="Archive"&&item.supportedTypes.includes('file'))
        if (hasArchivePrivilege.length){
            contextMenuItems.push({
                sub_menu: "ArchiveTo",
                label: "Archive to",
                iconSvgCallback: Utils.getArchiveSvg,
                onEvents: [
                {
                    event_name: "onClick",
                    event_handler: this.triggerShowArchiveSubmenu,
                    handler_args: [],
                },
            ],
            })
        }
      }
    },
    addRetrieveFromOption(contextMenuItems){
        let hasRetrievePrivilege = contextMenuItems.filter((item)=>item.action_name=="Retrieve"&&item.supportedTypes.includes('file'))
        if (hasRetrievePrivilege.length){
            contextMenuItems.push({
                sub_menu: "RetrieveFrom",
                label: "Retrieve From",
                iconSvgCallback: Utils.getImportSvg,
                onEvents: [
                {
                    event_name: "onClick",
                    event_handler: this.triggerShowRetrieveSubmenu,
                    handler_args: [],
                },
            ],
            })
        }
    },
    show(event, fileInfo) {
      this.showMenu = false;
      this.showMoreSubMenu = false;
      this.showNewSubMenu = false;
      this.showImportSubMenu = false;
      this.showExportSubMenu = false;
      this.showExportProxySubMenu = false;
      this.showArchiveToSubMenu = false
      this.showRetrieveFromSubmenu = false
      this.removeBinMoreContextMenu({id:"viewpdf"})
      if(!this.searchKeyword && ["no-access","browse"].includes(this.rootPathPermission.permission) && !['folder'].includes(fileInfo.file_type)){
        event.preventDefault();
        return
      }
      if (!this.eventsAttached) {
        this.setUpContextMenuActions();
      }
      let multiFiles;
      if (Object.keys(this.selectedFiles).length == 0){
        multiFiles = false
        if (Object.keys(fileInfo).length != 0) {
          this.selectElement(null, fileInfo);
        }
      }else{
        multiFiles = true
      }
      // if (!multiFiles){
      //     if (this.showViewPDFAction(fileInfo)){
      //         this.createViewPDFAction()
      //     }
      // }
      event.stopImmediatePropagation();
      this.contextMenuItems = this.getContextMenuItems(fileInfo, "DEFAULT", multiFiles);
      this.addArchiveToOption(this.contextMenuItems)
    //   this.addRetrieveFromOption(this.contextMenuItems)
      if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length){
        if(this.selectedFileInfo.archived){
          this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Archive')
          this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Folder Archive')
        }
      }else if(this.getSelectedMultipleFilesAsList(this.selectedFiles) && this.getSelectedMultipleFilesAsList(this.selectedFiles).length){
        let archivedFiles = this.getSelectedMultipleFilesAsList(this.selectedFiles).filter(e => e.archived);
        if(archivedFiles.length == this.getSelectedMultipleFilesAsList(this.selectedFiles).length){
          this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Archive')
        }
      }
      if (
        this.getRegisteredBinsMoreContextMenu().length != 0 &&
        this.getContextMenuItems(this.selectedFileInfo, "MOREACTIONS", multiFiles).length !=0) 
        {
        this.contextMenuItems.push({
          sub_menu: "MOREACTIONS",
          label: "More",
          iconSvgCallback: Utils.getMoreSvg,
          onEvents: [
            {
              event_name: "onClick",
              event_handler: this.triggerShowSubmenu,
              handler_args: [],
            },
          ],
        });
      }
      if (
        this.getRegisteredBinsNewContextMenu().length != 0 &&
        this.getContextMenuItems(this.selectedFileInfo, "NEWOPTION",multiFiles).length != 0
      ) {
        this.contextMenuItems.push({
          sub_menu: "NEWOPTION",
          label: "New",
          iconSvgCallback: Utils.getMoreSvg,
          onEvents: [
            {
              event_name: "onClick",
              event_handler: this.triggerShowSubmenuNew,
              handler_args: [],
            },
          ],
        });
      }
      if (
        this.getRegisteredBinsImportContextMenu().length != 0 &&
        this.getContextMenuItems(this.selectedFileInfo, "IMPORTOPTION",multiFiles).length != 0
      ) {
        this.contextMenuItems.push({
          sub_menu: "IMPORTOPTION",
          label: "Import",
          iconSvgCallback: Utils.getImportSvg,
          onEvents: [
            {
              event_name: "onClick",
              event_handler: this.triggerShowSubmenuImport,
              handler_args: [],
            },
          ],
        });
      }
      let assetReportsAction = this.getContextMenuItems(this.selectedFileInfo, "EXPORTOPTION", multiFiles);

      let fileTypes = [];
      let fileStates = [];
      let isAnyFilelocked = false;
      if(multiFiles){
        for(let op of Object.keys(this.selectedFiles)){
          let fileInfo = this.selectedFiles[op]
          fileTypes.push(fileInfo.file_type);
          fileStates.push(fileInfo.state);
          if(!isAnyFilelocked && 'lock' in fileInfo && fileInfo.lock){
            isAnyFilelocked = true
          }
          if(fileInfo.file_type == "folder" || fileInfo.state == "GROWING"){
            break;
          }
        }
      }else if(this.selectedFileInfo != undefined && Object.keys(this.selectedFileInfo).includes('file_type')){
        fileTypes.push(this.selectedFileInfo.file_type)
        fileStates.push(this.selectedFileInfo.state)
        if('lock' in this.selectedFileInfo && this.selectedFileInfo.lock){
          isAnyFilelocked = true
        }
      }
      if (((fileTypes.length > 0 && !fileTypes.includes("folder") && !fileStates.includes("GROWING") && !fileStates.includes("MARK FOR DELETE") &&
        this.deploymentBinsList != undefined &&
        this.deploymentBinsList.length > 0 && this.isEnabled("Export")) || (assetReportsAction && assetReportsAction.length > 0))  &&
        ((isAnyFilelocked && (!('lock_restricted_actions' in this.globalSettingsFromStartup) ||
         (('lock_restricted_actions' in this.globalSettingsFromStartup &&
          !this.globalSettingsFromStartup.lock_restricted_actions.includes("Export"))))) || !isAnyFilelocked)) {
        this.contextMenuItems.push({
          sub_menu: "EXPORTOPTION",
          label: "Export",
          iconSvgCallback: Utils.getDownloadSvg,
          onEvents: [
            {
              event_name: "onClick",
              event_handler: this.triggerShowExportSubmenu,
              handler_args: [],
            },
          ],
        });
      }
      if (fileTypes.length > 0 && !fileTypes.includes("folder") && !fileStates.includes("GROWING") && !fileStates.includes("MARK FOR DELETE") &&
        this.deploymentBinsList != undefined &&
        this.deploymentBinsList.length > 0 && this.isEnabled("Export Proxy") &&
        ((isAnyFilelocked && (!('lock_restricted_actions' in this.globalSettingsFromStartup) ||
         (('lock_restricted_actions' in this.globalSettingsFromStartup &&
          !this.globalSettingsFromStartup.lock_restricted_actions.includes("Export Proxy"))))) || !isAnyFilelocked)) {
        this.contextMenuItems.push({
          sub_menu: "EXPORTPROXYOPTION",
          label: "Export Proxy",
          iconSvgCallback: Utils.getDownloadSvg,
          onEvents: [
            {
              event_name: "onClick",
              event_handler: this.triggerShowExportProxySubmenu,
              handler_args: [],
            },
          ],
        });
      }
      this.attachShareOption(this.contextMenuItems, multiFiles)
      this.attachAIToolOption(this.contextMenuItems, multiFiles)
      this.attachOpenWithToolOption(this.contextMenuItems, multiFiles)

      event.preventDefault();
      this.x = event.clientX;
      this.y = event.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    isTrashPath() {
      if (
        typeof this.rootPathPermission == "undefined" ||
        Object.keys(this.rootPathPermission).length <= 0
      ) {
        return false;
      } else {
        let currentSelectedPath = "";
        currentSelectedPath = this.rootPathPermission.name_path;
        if (currentSelectedPath.startsWith("share://")) {
          currentSelectedPath = currentSelectedPath.replace("share://", "");
          let foldersList = currentSelectedPath.split("/");
          if (foldersList.length > 1) {
            return foldersList[1] == "Trash";
          }
        }
      }
      return false;
    },
    checkMultiSelectPrivilege(privilege, multiSelect=false){
      if (multiSelect){
        return privilege.multiple_selection_support
      }
      return true
    },
    isUserTypeAdministrator(){
      return Utils.isUserTypeAdmin(this.getLoggedInUserType);
    },
    checkMimetype(privilege, fileInfo){
      if (privilege.supported_mime_types.length !=0){
        try {
            if ("multi_mime_type_list" in fileInfo){
                if (fileInfo["multi_mime_type_list"].size > 1){
                    for (const src_mime_type of fileInfo["multi_mime_type_list"]) {
                        if (!(privilege.supported_mime_types.includes(src_mime_type))){
                            return false
                        }
                    }
                    return true
                }
            }   
        } catch {
            () => undefined 
        }
        
        if ("mime_type" in fileInfo){
            for (const mime_type of privilege.supported_mime_types) {
                if (fileInfo.mime_type.includes(mime_type)){
                    return true 
                }
            }

        }
        return false
      }else  if(privilege.action_name == "Folder Archive"){
        let lastIndexOfDot = fileInfo.file_name.lastIndexOf('.');
        let extension = fileInfo.file_name.slice(lastIndexOfDot, fileInfo.file_name.length);
        if(fileInfo.mime_type == "application/x-tar" || fileInfo.mime_type=="zip/zip" || [".gz", ".xz"].includes(extension)){
          return true;
        }else{
          return false;
        }  
      }
      return true
    },
    getDirsActions(fileInfo, elementType = "SelfElement", subMenu, multiSelect=false) {
      let binDirActionList = [];
      if (subMenu == "MOREACTIONS") {
        binDirActionList = this.getRegisteredBinsMoreContextMenu();
      } else if (subMenu == "NEWOPTION") {
        binDirActionList = this.getRegisteredBinsNewContextMenu();
      } else if (subMenu == "IMPORTOPTION") {
        binDirActionList = this.getRegisteredBinsImportContextMenu();
      } else if(subMenu == "EXPORTOPTION"){
        binDirActionList = this.getRegisteredExportContextMenu();
      } else if(subMenu == "EXPORTPROXYOPTION"){
        console.log("Ignore this case, As no other user actions will be servered from server for EXPORTPROXYOPTION")
      } else if(subMenu == "ArchiveTo"){
        return this.subMenuArchiveItems
      } else if(subMenu == "RetrieveFrom"){
        return this.subMenuRetrieveItems
      } else if(subMenu == "SHAREACTIONS"){
        binDirActionList = this.getRegisteredShareContextMenu();
      }else if(subMenu == "AITOOLACTIONS"){
        binDirActionList = this.getRegisteredAIToolsContextMenu();
      }else if(subMenu == "OPENWITHACTIONS"){
        binDirActionList = this.getRegisteresOpenWithContextMenu();
      }else {
        binDirActionList = this.getRegisteredBinsContextMenu();
      }
      let dirActionList = binDirActionList.filter(
        (privilege) =>
          (!this.isTrashPath() &&
          privilege.label != "Paste" &&
             privilege.requiredPermissions.includes(fileInfo.permissions) &&
            (privilege.supportedTypes.includes("folder") && privilege.supportedResources.includes("folder")) &&
             privilege.targetType.includes(elementType)  &&
            this.checkMultiSelectPrivilege(privilege, multiSelect)) ||
          (!this.isTrashPath() &&
            privilege.label == "MoveToTrash" &&
            privilege.requiredPermissions.includes(fileInfo.permissions)) ||
          (this.isTrashPath() &&
            ["RestoreFromTrash", "RemoveFromTrash"].includes(privilege.label) &&
            privilege.requiredPermissions.includes(fileInfo.permissions)) ||
          (privilege.label == "Paste" &&
            this.getPasteActionInfoFromInMem != null &&
            typeof this.getPasteActionInfoFromInMem != "undefined" &&
            !this.isTrashPath() &&
            privilege.requiredPermissions.includes(fileInfo.permissions) &&
            (privilege.supportedResources.includes("files")||privilege.supportedResources.includes("pages")))
      );
      //If selection inside folder level
      if (typeof fileInfo != "undefined" && Object.keys(fileInfo).includes("state")){
        let filtered_dir_actions = dirActionList.filter(
                                    (privilege) => (privilege.requiredStates.includes(fileInfo.state)))
        return filtered_dir_actions
      }
      return dirActionList;
    },
    getFilesActions(fileInfo, elementType = "SelfElement", subMenu, multiSelect=false) {
      let binFilesActionsList = [];
      if (subMenu == "MOREACTIONS") {
        binFilesActionsList = this.getRegisteredBinsMoreContextMenu();
         try{
          if(fileInfo && Object.prototype.hasOwnProperty.call(fileInfo,'mime_type') 
              && ['image'].indexOf(Utils.getMediaType(fileInfo.mime_type)) == -1){
               binFilesActionsList =  binFilesActionsList.filter(op => op && op.action_name != 'manage-asset-annotaion');
          }
        }catch(e){console.log(e)}
      } else if (subMenu == "NEWOPTION") {
        binFilesActionsList = this.getRegisteredBinsNewContextMenu();
      } else if (subMenu == "IMPORTOPTION") {
        binFilesActionsList = this.getRegisteredBinsImportContextMenu();
      } else if(subMenu == "EXPORTOPTION"){
        binFilesActionsList = this.getRegisteredExportContextMenu();
      } else if(subMenu == "EXPORTPROXYOPTION"){
        console.log("Ignore this case, As no other user actions will be servered from server for EXPORTPROXYOPTION")
      }else if(subMenu == "ArchiveTo"){
        return this.subMenuArchiveItems
      } else if(subMenu == "RetrieveFrom"){
        return this.subMenuRetrieveItems
      } else if(subMenu == "SHAREACTIONS"){
        binFilesActionsList = this.getRegisteredShareContextMenu();
      }else if(subMenu == "AITOOLACTIONS"){
        binFilesActionsList = this.getRegisteredAIToolsContextMenu();
      }else if(subMenu == "OPENWITHACTIONS"){
        binFilesActionsList = this.getRegisteresOpenWithContextMenu();
      }else {
        binFilesActionsList = this.getRegisteredBinsContextMenu();
      }
      let removeLockAction = false;
      let removeUnlockAction = false;
      if(multiSelect){
        let lockedFileEntries = [];
        let unlockedFileEntries = [];
        for(let _id in this.selectedFiles){
          if(this.selectedFiles[_id].asset_type == 'subclip'){
            removeLockAction = true;
            removeUnlockAction = true;
            break
          }
          if('lock' in this.selectedFiles[_id] && this.selectedFiles[_id].lock){
            lockedFileEntries.push(_id);
          }else{
            unlockedFileEntries.push(_id);
          }
        }
        if(lockedFileEntries.length > 0 && unlockedFileEntries.length > 0){
          //Selected files are the combination of lock,Unlock hence removing the actions
          removeLockAction = true;
          removeUnlockAction = true;
        }else if(lockedFileEntries.length > 0 && unlockedFileEntries.length == 0){
          //Selected files are Only locked files, hence enabling only Unlock action to Unlock
          removeLockAction = true;
          removeUnlockAction = false;
        }else if(lockedFileEntries.length == 0 && unlockedFileEntries.length > 0){
          //Selected files are Only Unlocked files, hence enabling only lock action to lock
          removeLockAction = false;
          removeUnlockAction = true;
        }
      }else{
        if(fileInfo && 'lock' in fileInfo && fileInfo.lock){
          removeLockAction = true
        }else if(fileInfo && ('lock' in fileInfo && !fileInfo.lock) || !('lock' in fileInfo)){
          removeUnlockAction = true
        }
      }
      if(removeLockAction){
        binFilesActionsList = binFilesActionsList.filter(op=>!['Lock'].includes(op.label))
        //Restrict the useraction that are configured from 'Locked Files' global settings
        binFilesActionsList = binFilesActionsList.filter(op=>!('lock_restricted_actions' in this.globalSettingsFromStartup && this.globalSettingsFromStartup.lock_restricted_actions.includes(op.id)))

      }
      if(removeUnlockAction){
        binFilesActionsList = binFilesActionsList.filter(op=>!['Unlock'].includes(op.label))
      }
      return binFilesActionsList.filter(
        (privilege) =>
          (!this.isTrashPath() &&
            privilege.requiredPermissions.includes(fileInfo.permissions) &&
            (privilege.supportedTypes.includes("file") || privilege.supportedTypes.includes("page")) &&
            privilege.targetType.includes(elementType) &&
            (privilege.supportedResources.includes("files") || privilege.supportedResources.includes("pages")) &&
            this.checkMultiSelectPrivilege(privilege, multiSelect) &&
            this.checkMimetype(privilege, fileInfo, multiSelect) &&
            privilege.requiredStates.includes(fileInfo.state)) ||
          (!this.isTrashPath() &&
            privilege.label == "MoveToTrash" &&
            privilege.requiredPermissions.includes(fileInfo.permissions)) ||
          (this.isTrashPath() &&
            ["RestoreFromTrash", "RemoveFromTrash"].includes(privilege.label) &&
            privilege.requiredPermissions.includes(fileInfo.permissions))
      );
    },
    getCurrentFolderActions(subMenu) {
      if (this.currentFolderInfo != undefined &&
        Object.keys(this.currentFolderInfo).length == 0 &&
        this.folderStructure.length == 1
      ) {
        let binAccessRight = this.getBinAccessRight();
        let accessRight = { permissions: "no-access" };
        if (binAccessRight.length != 0) {
          accessRight = { permissions: binAccessRight[0]["access_right"] };
        }
        return this.getDirsActions(accessRight, "ParentElement", subMenu, false);
      } else {
        return this.getDirsActions(
          this.currentFolderInfo,
          "ParentElement",
          subMenu,
          false
        );
      }
    },
    getContextMenuItems(fileInfo, subMenu, multiSelect=false) {
      console.log("this.selectedFileInfo," , this.selectedFileInfo, this.currentFolderInfo, fileInfo)

      let elementType = "SelfElement"
      let targetFile = Object.assign({}, fileInfo)
      let targetState = fileInfo.state
      if (multiSelect){
        let selectedFilesState = new Set()
        let selectedMimeType = new Set()
        let selectedPermission = new Set()
        for (const file_uid of Object.keys(this.selectedFiles)){
          selectedFilesState.add(this.selectedFiles[file_uid].state)
          selectedMimeType.add(this.selectedFiles[file_uid].mime_type.split("/")[0])
          selectedPermission.add(this.selectedFiles[file_uid].permissions)
        }
        targetState = selectedFilesState.size ==1?Array.from(selectedFilesState)[0]:
                               selectedFilesState.has("GROWING")?"GROWING":selectedFilesState.has("ERROR")?"ERROR":
                               selectedFilesState.has("DELETED")?"DELETED":selectedFilesState.has("MARK FOR DELETE")?"MARK FOR DELETE":
                               selectedFilesState.has("READING")?"READING":selectedFilesState.has("WRITING")?"WRITING":
                               selectedFilesState.has("LOCKED")?"LOCKED":selectedFilesState.has("READY")?"READY":"READY"


        let targetMimeType = selectedMimeType.size == 1?Array.from(selectedMimeType)[0]:"unknown"
        let targetPerm = selectedPermission.size == 1?Array.from(selectedPermission)[0]:
                         selectedPermission.has("no-access")?"no-access":selectedPermission.has("default-access")?"default-access":
                         selectedPermission.has("browse")?"browse":selectedPermission.has("read")?"read":
                         selectedPermission.has("read-write")?"read-write":selectedPermission.has("read-modify")?"read-modify":
                         selectedPermission.has("full-control")?"full-control":"no-access"

        targetFile = Object.assign({},{file_type:"file", permissions:targetPerm, state:targetState, "mime_type":targetMimeType, "multi_mime_type_list": selectedMimeType})
      }
      else if(!multiSelect && this.selectedFileInfo.state == "MARK FOR DELETE"){
        targetState = "MARK FOR DELETE"
      }
      targetFile.state = targetState

      if (targetFile.file_type == "folder") {
        return this.getDirsActions(targetFile, elementType, subMenu, multiSelect);
      } else if (["file","page"].includes(targetFile.file_type)) {
        return this.getFilesActions(targetFile, elementType, subMenu, multiSelect);
      } else if(!multiSelect){
        return this.getCurrentFolderActions(subMenu);
      }
    },
    getMediaTypeIcons(item) {
      if (item.startsWith("audio")) return Utils.getAudioPlayIcon();
      if (item.startsWith("video")) return Utils.getVideoPlayIcon();
    },
    getSvgIconsOfMediaTypes(path, type) {
      return Utils.determineSvgIconForType(path, type);
    },
    getBinAccessRight() {
      return this.getLoggedInUserAccessControl.bins.filter(
        (binAccessRight) =>
          binAccessRight.bin_id == this.binSelected &&
          binAccessRight.path == `share://${this.binSelected}`
      );
    },
    submitMarkForDelete(){
      let postData = (fileInfo) => {
        let payload = {};
        payload._id = fileInfo._id
        payload.job_name = "Mark For Delete";
        payload.element_type = "file";
        payload.file_type = fileInfo.file_type;
        payload.from_context = "bins";
        payload.size = fileInfo.size;
        payload.file_uid = fileInfo.file_uid;
        payload.parent_id_path = fileInfo.parent_id_path;
        payload.version_id = fileInfo.version_id;
        payload.asset_id = fileInfo.asset_id;
        payload.resource_name = fileInfo.file_name || fileInfo.dir_name;
        this.createNewJob(payload)
      }
      if(Object.keys(this.selectedFileInfo).length){
        postData(this.selectedFileInfo);
      }else{
        for(let _id in this.selectedFiles)
          postData(this.selectedFiles[_id])
      }
      this.eOMenu = false;
    },
    submitRestore(){
      let postData = (fileInfo) => {
          let payload = {};
          payload.asset_id = fileInfo.asset_id
          payload.parent_id_path = fileInfo.parent_id_path
          payload.element_type = "file";
          payload.job_name = "Restore";
          payload.from_context = "bins";
          payload.resource_name = fileInfo.file_name || fileInfo.dir_name;
          payload.size = fileInfo.size;
          payload.file_uid = fileInfo.file_uid;
          payload.version_id = fileInfo.version_id;
          payload._id = fileInfo._id;
          payload.file_type = fileInfo.file_type;
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          });
      }
      if(Object.keys(this.selectedFileInfo).length){
           postData(this.selectedFileInfo);
       }else{
          for(let _id in this.selectedFiles)
              postData(this.selectedFiles[_id])
       }
      this.eOMenu = false;
    },
    submitDeletePermanently(){
      let postData = (fileInfo) => {
          let payload = {};
          payload.asset_type = fileInfo.asset_type
          payload.parent_id_path = fileInfo.parent_id_path
          payload.element_type = "file";
          payload.job_name = "Delete Permanently";
          payload.from_context = "bins";
          payload.resource_name = fileInfo.slug_name || fileInfo.dir_name;
          payload.size = fileInfo.size;
          payload.file_uid = fileInfo.file_uid;
          payload.version_id = fileInfo.version_id;
          payload.asset_id = fileInfo.asset_id;
          payload._id = fileInfo._id
          payload.file_type = fileInfo.file_type;
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else if(data.error_message) {
              this.$toast.error(data.error_message);
            }
          });
      }
      if(Object.keys(this.selectedFileInfo).length){
        let message = "Are you sure you want to delete selected file "+ (this.selectedFileInfo.slug_name || this.selectedFileInfo.dir_name) +" permanently?"
        if(confirm(message)){
          postData(this.selectedFileInfo)
        }
      }else{
        let message = "Are you sure you want to delete "+ Object.keys(this.selectedFiles).length +" selected files permanently?"
        if(confirm(message)){
          for(let _id in this.selectedFiles)
            postData(this.selectedFiles[_id])
        }
      }
      this.eOMenu = false;
    },
    submitForceDeletePermanently(){
      let postData = (fileInfo) => {
          let payload = {};
          payload.asset_type = fileInfo.asset_type
          payload.parent_id_path = fileInfo.parent_id_path
          payload.element_type = "file";
          payload.job_name = "Force Delete Permanently";
          payload.from_context = "bins";
          payload.resource_name = fileInfo.slug_name || fileInfo.dir_name;
          payload.size = fileInfo.size;
          payload.file_uid = fileInfo.file_uid;
          payload.version_id = fileInfo.version_id;
          payload.asset_id = fileInfo.asset_id;
          payload._id = fileInfo._id
          payload.file_type = fileInfo.file_type;
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          });
      }
      if(Object.keys(this.selectedFileInfo).length){
        let message = "Are you sure you want to delete selected file/folder "+ (this.selectedFileInfo.slug_name || this.selectedFileInfo.dir_name) +" permanently?"
        if(confirm(message)){
          postData(this.selectedFileInfo)
        }
      }else{
        let message = "Are you sure you want to delete "+ Object.keys(this.selectedFiles).length +" selected files permanently?"
        if(confirm(message)){
          for(let _id in this.selectedFiles)
            postData(this.selectedFiles[_id])
        }
      }
      this.eOMenu = false;
    },
    submitRemoveFromTrash() {
      this.submitNewJob("Delete");
      this.eOMenu = false;
    },
    submitRestoreFromTrash() {
      this.submitNewJob("Restore");
      this.eOMenu = false;
    },
    submitCopyAction(event, fileinfo) {
      let targetFile = {}
      
      if (Object.keys(this.selectedFiles).length == 0){
        targetFile[fileinfo.file_uid] = fileinfo
      }else{
        Object.assign(targetFile, this.selectedFiles)
      }
      
      this.createPasteAction(targetFile, "copy");
      this.eOMenu = false;
    },
    submitMoveToTrash() {
      this.submitNewJob("MoveToTrash");
      this.eOMenu = false;
    },
    submitCutAction(event, fileinfo) {
      let targetFile = {}
      
      if (Object.keys(this.selectedFiles).length == 0){
        targetFile[fileinfo.file_uid] = fileinfo
      }else{
        Object.assign(targetFile, this.selectedFiles)
      }

      this.createPasteAction(targetFile, "cut");
      this.eOMenu = false;
    },
    submitUploadAction() {
      this.fileUploadAction(false);
      this.eOMenu = false;
    },
    fileUploadAction(newVersion){
      let query = {
        path: this.rootPathPermission.name_path, 
        newVersion:newVersion?newVersion:false,
        bin_id:Utils.getBinIdFromPath(this.rootPathPermission.name_path)
      }
      if (Object.keys(this.selectedFileInfo).length!=0 && Object.keys(this.selectedFiles).length==0){
        Object.assign(query, {parentfileUid: this.selectedFileInfo.file_uid})
      }
      this.$router.push({
        name: "upload",
        params:{
          parentinfo: this.$route,
        },
        query:query
      })
    },
    uploadAssetNewVersion(){
      this.fileUploadAction(true)
      this.eOMenu = false;
    },
    updateAssetNewVersion(){
      console.log(" updateAssetNewVersion updateAssetNewVersion")
      this.eOMenu = false;
    },
    submitPasteAction() {
      this.submitActionHolder();
    },
    handleTagMetadataAssetHoverAction(file={}){
      this.selectedFileInfo = file;
      if(this.isFileActionEnabled('tag-metadata',file.permissions)){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"metadata-manager",
          params:{selectedFileInfo:this.selectedFileInfo,assetId:this.selectedFileInfo.asset_id,parentinfo:this.$route,subComponentToBeUsed:{"subclip-component":"bin-sub-clips-manager-as-child","mediaedit-component":"PartialRetrieve-as-child","asset-video-transcript":"bin-video-transcript-as-child"}}
        })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "metadata-manager";
      }else{
        this.tMRuestorAction();
      }
    },

    archiveRequest(){
      let assetIds = []
      if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
        assetIds.push(this.selectedFileInfo.asset_id)
      }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
        assetIds = Object.keys(this.selectedFiles)
      }
      if(assetIds && assetIds.length > 0){
        this.updateLabelsForArchiveRequest({"asset_ids":assetIds}).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            if('message' in data){
              this.$toast.success(data.message);
            }else{
              this.$toast.success("Archive Request submitted successfully")
            }
          } else {
              this.$toast.error(data.message);
          }
        })
      }
    },
    retrieveRequest(){
      let assetIds = []
      if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
        assetIds.push(this.selectedFileInfo.asset_id)
      }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
        assetIds = Object.keys(this.selectedFiles)
      }
      if(assetIds && assetIds.length > 0){
        this.updateLabelsForRetrieveRequest({"asset_ids":assetIds}).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            if('message' in data){
              this.$toast.success(data.message);
            }else{
              this.$toast.success("Retrieve Request submitted successfully")
            }
          } else {
              this.$toast.error(data.message);
          }
        })
      }
    },
    transcoderTarget1Request(){
      let assetIds = []
      if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
        assetIds.push(this.selectedFileInfo.asset_id)
      }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
        assetIds = Object.keys(this.selectedFiles)
      }
      if(assetIds && assetIds.length > 0){
        this.updateLabelsForTranscoderTarget1Request({"asset_ids":assetIds}).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            if('message' in data){
              this.$toast.success(data.message);
            }else{
              this.$toast.success("Transcode Target-1 Request submitted successfully")
            }
          } else {
              this.$toast.error(data.message);
          }
        })
      }
    },
    transcoderTarget2Request(){
      let assetIds = []
      if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
        assetIds.push(this.selectedFileInfo.asset_id)
      }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
        assetIds = Object.keys(this.selectedFiles)
      }
      if(assetIds && assetIds.length > 0){
        this.updateLabelsForTranscoderTarget2Request({"asset_ids":assetIds}).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            if('message' in data){
              this.$toast.success(data.message);
            }else{
              this.$toast.success("Transcode Target-2 Request submitted successfully")
            }
          } else {
              this.$toast.error(data.message);
          }
        })
      }
    },
    manageAssetLinks(){
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = 'manage-assets-link';
      this.eOMenu = false;
    },
    tagMetadataBinsActions(event, selectedMultiFiles) {
      if(Object.keys(selectedMultiFiles).length <= 1){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"metadata-manager",
          params:{selectedFileInfo:this.selectedFileInfo,assetId:this.selectedFileInfo.asset_id,parentinfo:this.$route,subComponentToBeUsed:{"subclip-component":"bin-sub-clips-manager-as-child","mediaedit-component":"PartialRetrieve-as-child","asset-video-transcript":"bin-video-transcript-as-child"}}
        })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "metadata-manager";
      }
      this.eOMenu = false;
    },
    setLabelToAsset(){
      if(Object.keys(this.selectedFileInfo).length >= 0 || Object.keys(this.selectedFiles).length >= 0){
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "set-label-to-asset"
        this.eOMenu = false;
      }else{
        alert("Please select valid files.")
        return
      }
    },
    tMRuestorAction(){
      // this.$router.push({
      //   name:"metadata-requestor",
      // })
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "metadata-requestor";
      this.eOMenu = false;
    },
    editAndShareAction(){
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "edit-and-share";
      this.eOMenu = false;
    },
    bulkTagMetadataBinsActions(){
      // if(Object.keys(selectedMultiFiles).length <= 1){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"bulk-tagmetadata-manager",
        })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "bulk-tagmetadata-manager";
      // }
      this.eOMenu = false;
    },
    imageAnnotationAction(){
      this.ModalParentRoute = Object.assign({}, this.$route);
        let annotationData = {thumbnail:'',asset:{}};
        annotationData.asset = this.selectedFileInfo;
        annotationData.thumbnail = Utils.convertToLoginIPDomainName(this.selectedFileInfo.proxy_info.thumbnail_uri);
        this.$router.push({
          name:"file-image-annotation-with-comment",
          params:{
            id:this.selectedFileInfo.asset_id,
            annotationData:annotationData,
            parentinfo: this.$route,
          }
        })
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "file-image-annotation-with-comment";
      this.eOMenu = false;
    },
    manageMediaVersion(){
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = 'manage-version';
      this.eOMenu = false;
    },
    subclipsBinsActions(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"bin-sub-clips-manager",
        params:{assetId: this.selectedFileInfo.asset_id, fileInfo:Object.assign({}, this.selectedFileInfo),parentinfo:this.$route}
      })
      this.openTagMetadataModel = "bin-sub-clips-manager";
      this.isMetadataManagerVisible = true;
      this.openSubclips = true;
      this.eOMenu = false;
    },
    subclipsBinsActionsThroughMetadataDock(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"metadata-dock-bin-sub-clips-manager",
        params:{assetId: this.selectedFileInfo._id, fileInfo:Object.assign({}, this.selectedFileInfo),parentinfo:this.$route}
      })
      this.openTagMetadataModel = "metadata-dock-bin-sub-clips-manager";
      this.isMetadataManagerVisible = true;
      this.openSubclips = true;
      this.eOMenu = false;
    },
    reviewBinsAction(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"new-review",
      })
      this.openTagMetadataModel = 'new-review';
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    },
    submitOBDAction(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"file-object-detection",
        params:{filesInfo:this.selectedFileInfo,parentinfo:this.$route}
      })
      this.openTagMetadataModel = 'object-detection';
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    },
    shareWithUser(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"share-with-user",
        params:{filesInfo:this.selectedFileInfo,parentinfo:this.$route}
      })
      this.openTagMetadataModel = 'share-with-user';
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    },

    shareWithUserFromGlobalBtn(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"share-with-user-from-global-btn",
        params:{filesInfo:this.selectedFileInfo,parentinfo:this.$route}
      })
      this.openTagMetadataModel = 'share-with-user-from-global-btn';
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    },

    shareViaEmail(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"share-via-email",
      })
      this.openTagMetadataModel = 'share-via-email';
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    },

    tasksBinsAction(){
      // this.openTagMetadataModel = 'new-tasks-issues';
      // this.isMetadataManagerVisible = true;
      this.$emit('handleNewTaskOrIssueAction');
      this.eOMenu = false;
    },
    shareCatelogAction(){
      this.$emit('handleShareAction',{});
      this.eOMenu = false;
    },
    handleShareAction(file){
      this.$emit('handleShareAction', file)
    },
    copyAssetURL(){
      this.setClipBoardText(this.selectedFileInfo);
      this.eOMenu = false;
    },
    setClipBoardText(file){
      let copiedLink = ""
      if(Object.keys(file).length && "access_url" in file){
        copiedLink = file.access_url;
      }
      if(copiedLink.trim().length <= 0){
        alert("Link is not avaialble.");
      }else{
        navigator.clipboard.writeText(copiedLink);
      }
      this.eOMenu = !this.eOMenu;
    },
    handleDownloadAction(file, downloadProxy=false){
      if(this.selectedFiles && Object.keys(this.selectedFiles).length){
        let filesList = Object.values(this.selectedFiles).map(file => ({...file,download_proxy: downloadProxy}));
        this.setDownloadFilesArr({key:Utils.getUUID(),value:filesList})
      }else{
        let payload = {};
        payload.bin_id = file.bin_id;
        payload.element_type = "file";
        if(downloadProxy){
          payload.job_name = "Download Proxy"
        }else{
          payload.job_name = "Download";
        }
        payload.file_name = file.file_name;
        payload.path = file.path;
        // let fileMimeType = file.mime_type;
        let fileName = file.file_name;
        this.initiateDownloadJob(payload).then((data) => {
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            let jobIdFromResponse = data.job_id;
            let jobFileName = data.file_name;
            let payload = { job_id: "job_id=" + jobIdFromResponse };
            // let downnloadUrl = `${Constants.downloadUrl}?${payload.job_id}`;
            /*         this.downloadFile(payload).then((data) => {
                      const blob = new Blob([data], {
                        type: fileMimeType,
                      });
                      const link = document.createElement("a");
                      link.href = URL.createObjectURL(blob);
                      link.download = fileName;
                      link.click();
                      URL.revokeObjectURL(link.href);
                    }); */

            /*         let iframe = document.createElement('iframe');
            iframe.style.display = "none";
            iframe.src = downnloadUrl;
            document.body.appendChild(iframe); */

              const link = document.createElement("a");
              if(downloadProxy){
                link.href = `${Constants.downloadProxyUrl}?${payload.job_id}`;
                link.download = jobFileName;
              }else{
                link.href = `${Constants.downloadUrl}?${payload.job_id}`;
                link.download = fileName;
              }
              link.click(); 
          
              console.log("Download initiated");
          } else {
            this.$toast.error(data.message);
          }
        });
      }
    },
    submitDownloadJob() {
      this.handleDownloadAction(this.selectedFileInfo)
      this.eOMenu = false;
    },
    submitDownloadProxyAction(){
      this.handleDownloadAction(this.selectedFileInfo, true);
      this.eOMenu = false;
    },
    archiveto(pool_id){
        let payload = {};
      if(Object.keys(this.selectedFileInfo).length){
      payload.bin_id = this.selectedFileInfo.bin_id;
      payload.file_name = this.selectedFileInfo.file_name;
      payload.path = this.selectedFileInfo.path;
      payload.element_type = "file";
      payload.job_name = "Archive";
      payload.file_uid = this.selectedFileInfo.file_uid;
      payload.pool_id = pool_id
      this.createNewJob(payload).then((data) => {
        if (data.statusCode == 200) {
          this.$toast.success(data.message);
        } else {
          this.$toast.error(data.message);
        }
      });
      }else{
        for (const file_uid of Object.keys(this.selectedFiles)) {
          payload.bin_id = this.selectedFiles[file_uid].bin_id;
          payload.file_name = this.selectedFiles[file_uid].file_name;
          payload.path = this.selectedFiles[file_uid].path;
          payload.element_type = "file";
          payload.job_name = "Archive";
          payload.file_uid = file_uid;
          payload.pool_id = pool_id
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          });
        }
      }
    },
    submitArchiveJob(){
      let payload = {};
      if(Object.keys(this.selectedFileInfo).length){
      payload.bin_id = this.selectedFileInfo.bin_id;
      payload.file_name = this.selectedFileInfo.file_name;
      payload.path = this.selectedFileInfo.path;
      payload.element_type = "file";
      payload.job_name = "Archive";
      payload.file_uid = this.selectedFileInfo.file_uid;
      // payload.pool_id = this.getDefaultPoolfromInMem.pool_id
      this.createNewJob(payload).then((data) => {
        if (data.statusCode == 200) {
          this.$toast.success(data.message);
        } else {
          this.$toast.error(data.message);
        }
      });
      }else{
        for (const file_uid of Object.keys(this.selectedFiles)) {
          payload.bin_id = this.selectedFiles[file_uid].bin_id;
          payload.file_name = this.selectedFiles[file_uid].file_name;
          payload.path = this.selectedFiles[file_uid].path;
          payload.element_type = "file";
          payload.job_name = "Archive";
          payload.file_uid = file_uid;
          payload.pool_id = this.getDefaultPoolfromInMem.pool_id
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          });
        }
      }
      this.eOMenu = false;
    },
    submitFolderArchiveJob(){
      let payload = {};
      if(Object.keys(this.selectedFileInfo).length){
        payload.element_type = "file";
        payload.job_name = "Folder Archive";
        payload.file_uid = this.selectedFileInfo.file_uid;
        this.createNewJob(payload).then((data) => {
          if (data.statusCode == 200) {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }
        });
      }  
      this.eOMenu = false;
    },
    retrieveFrom(pool_id){
      let payload = {};
      if(Object.keys(this.selectedFileInfo).length){
      payload.bin_id = this.selectedFileInfo.bin_id;
      payload.file_name = this.selectedFileInfo.file_name;
      payload.path = this.selectedFileInfo.path;
      payload.element_type = "file";
      payload.job_name = "Retrieve";
      payload.file_uid = this.selectedFileInfo.file_uid;
      payload.pool_id = pool_id
      this.createNewJob(payload).then((data) => {
        console.log(" retrieveFrom : resp keys ",Object.keys(data) )
        if (data.statusCode == 200) {
          this.$toast.success("Retrieve job submitted");
        } else {
          this.$toast.error(data.message);
        }
      });
      }else{
        let postedJobs = []
        for (const file_uid of Object.keys(this.selectedFiles)) {
          payload.bin_id = this.selectedFiles[file_uid].bin_id;
          payload.file_name = this.selectedFiles[file_uid].file_name;
          payload.path = this.selectedFiles[file_uid].path;
          payload.element_type = "file";
          payload.job_name = "Retrieve";
          payload.file_uid = file_uid;
          payload.pool_id = pool_id
          let jobsPostPromise = this.createNewJob(payload)
          jobsPostPromise.file_name = this.selectedFiles[file_uid].file_name;
          postedJobs.push(jobsPostPromise)
        }
        Promise.all(postedJobs).then(allJobsList=>{
            let failedEntries = []
            let retrievedEntries = []
            for(let i=0; i<allJobsList.length ; i++){
              let eachJob  = allJobsList[i]
              if (eachJob.statusCode == 200) {
                retrievedEntries.push(eachJob)
              } else {
                failedEntries.push(eachJob.message)
              }
            }
            if(retrievedEntries && retrievedEntries.length > 0){
              this.$toast.success("Retrieve job submitted");
            }
            if(failedEntries && failedEntries.length > 0){
              if(failedEntries.length == 1){
                this.$toast.error(`${failedEntries[0]}.`)
              }else{
                this.$toast.error(`${failedEntries[0]} \n + Failed to retrieve ${failedEntries.length-1} More files`);
              }
            }
        })
      }  
    },
    getPoolByPriority(){
        for (const device of Object.values(this.getPoolDevicesfromInMem()).sort((a,b)=>a.priority-b.priority) ){
            let selected_pool = Object.values(this.getPoolsfromInMem()).filter((pool)=>pool.pool_owner==device.device_id)
            if (selected_pool.length){
                return selected_pool[0]
            }
        }
        return this.getDefaultPoolfromInMem
    },
    submitFolderRetrieveJob(){
      if(Object.keys(this.selectedFileInfo).length <= 0){
        alert("Please select valid folder to retrieve.")
        return
      }
      let payload = {
                      job_name:"Folder Retrieve",
                      id_path:this.selectedFileInfo.parent_id_path+"/"+this.selectedFileInfo._id,
                      element_type:"file"}
      this.createNewJob(payload).then((data) => {
        if (data.statusCode == 200) {
          this.$toast.success(data.message);
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    submitRetrieveAsAction(){
      this.closeSubmenu();
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "retrieve-as"
      this.eOMenu = false;
    },
    submitRetrieveJob(){
      let payload = {};
      this.eOMenu = false;
      if(Object.keys(this.selectedFileInfo).length){
      payload.bin_id = this.selectedFileInfo.bin_id;
      payload.file_name = this.selectedFileInfo.file_name;
      payload.path = this.selectedFileInfo.path;
      payload.element_type = "file";
      payload.job_name = "Retrieve";
      payload.file_uid = this.selectedFileInfo.file_uid;
      payload.pool_id = this.getPoolByPriority().pool_id
      this.createNewJob(payload).then((data) => {
        console.log(" retrieveFrom : resp keys ",Object.keys(data) )
        if (data.statusCode == 200) {
          this.$toast.success("Retrieve job submitted");
        } else {
          this.$toast.error(data.message);
        }
      });
      }else{
        let postedJobs = []
        for (const file_uid of Object.keys(this.selectedFiles)) {
          payload.bin_id = this.selectedFiles[file_uid].bin_id;
          payload.file_name = this.selectedFiles[file_uid].file_name;
          payload.path = this.selectedFiles[file_uid].path;
          payload.element_type = "file";
          payload.job_name = "Retrieve";
          payload.file_uid = file_uid;
          payload.pool_id = this.getPoolByPriority().pool_id
          let jobsPostPromise = this.createNewJob(payload)
          jobsPostPromise.file_name = this.selectedFiles[file_uid].file_name;
          postedJobs.push(jobsPostPromise)
        }
        Promise.all(postedJobs).then(allJobsList=>{
            let failedEntries = []
            let retrievedEntries = []
            for(let i=0; i<allJobsList.length ; i++){
              let eachJob  = allJobsList[i]
              if (eachJob.statusCode == 200) {
                retrievedEntries.push(eachJob)
              } else {
                failedEntries.push(eachJob.message)
              }
            }
            if(retrievedEntries && retrievedEntries.length > 0){
              this.$toast.success("Retrieve job submitted");
            }
            if(failedEntries && failedEntries.length > 0){
              if(failedEntries.length == 1){
                this.$toast.error(`Failed to retrieve ${failedEntries[0]}.`)
              }else{
                this.$toast.error(`${failedEntries[0]} \n + Failed to retrieve ${failedEntries.length-1} More files`);
              }
            }
        })
      }
    },
    lockOrUnlockAssets(lockState=false){
      let selectedAssetIdList = []
      if(Object.keys(this.selectedFileInfo).length){
        selectedAssetIdList.push(this.selectedFileInfo.file_uid);
      }else{
        for(let _id in this.selectedFiles){
          if(this.selectedFiles[_id].asset_type == 'subclip'){
            continue;
          }
          selectedAssetIdList.push(this.selectedFiles[_id].file_uid);
        }
      }
      let payload = {file_uid:selectedAssetIdList,element_type: "assets",job_name: "Lock/Unlock",asset_lock: lockState}
      this.createNewJob(payload).then((data) => {
        if (data.statusCode == 200) {
          this.$toast.success("Job submitted successfully");
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    lockSelectedAsset(){
      this.lockOrUnlockAssets(true)
    },
    unlockSelectedAsset(){
      this.lockOrUnlockAssets()
    },
    createFolderAction() {
      // this.$router.push({
      //   name:"create-folder",
      // })
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "create-folder";
      this.eOMenu = false;
    },
    renameAction() {
      // this.$router.push({
      //   name:"rename-folder",
      // })
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "rename-folder";
      this.eOMenu = false;
    },
    modifyTTLAction(){
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "modify-ttl";
      this.eOMenu = false;
    },
    previewBinsActions(){
      let newUrl = new URL(`/assets/${this.selectedFileInfo.asset_id}/view`, location.href);
      window.open(newUrl,'_blank');
      this.eOMenu = false;
    },
    openDialogForExternalPlugin() {
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"external-plugin-manager",
      })
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "external-plugin-manager";
    },
    submitPartialRetrieveAction(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"PartialRetrieve",
        params:{fileInfo:this.selectedFileInfo && Object.keys(this.selectedFileInfo).length?this.selectedFileInfo:this.selectedFiles,isMultipleFilesSelected:this.selectedFiles && Object.keys(this.selectedFiles).length?true:false,parentinfo:this.$route}
      })
      this.openTagMetadataModel = 'PartialRetrieve';
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    },
    submitBinsSubclipTranscript(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"bins-metadata-dock-video-transcript-manager",
        params:{fileInfo:Object.keys(this.selectedFileInfo).length?this.selectedFileInfo:this.selectedFiles,isMultipleFilesSelected:this.selectedFiles & Object.keys(this.selectedFiles).length?true:false,parentinfo:this.$route}
      })
      this.openTagMetadataModel = "bins-metadata-dock-video-transcript-manager"
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    },
    submitOCRAction(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"OCR",
      })
      this.openTagMetadataModel = 'OCR';
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    },
    submitTranscript(){
      if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length){
        if(this.selectedFileInfo.mime_type.startsWith("video/")){
          this.ModalParentRoute = Object.assign({}, this.$route)
          this.$router.push({
            name:"VideoTranscript",
          })
          this.openTagMetadataModel = 'VideoTranscript';
          this.isMetadataManagerVisible = true;
          this.eOMenu = false;
        }else if(this.selectedFileInfo.mime_type.startsWith("audio/")){
          this.ModalParentRoute = Object.assign({}, this.$route)
          this.$router.push({
            name:"AudioTranscript",
          })
          this.openTagMetadataModel = 'AudioTranscript';
          this.isMetadataManagerVisible = true;
          this.eOMenu = false;
        }
      }
    },
    submitFaceDetectionAction(){
      this.ModalParentRoute = Object.assign({}, this.$route)
      this.$router.push({
        name:"file-facedetection",
      })
      this.openTagMetadataModel = 'facedetection';
      this.isMetadataManagerVisible = true;
      this.eOMenu = false;
    }, 
    openShareInChat(){
      this.ModalParentRoute = Object.assign({}, this.$route);
      this.$router.push({
        name:"share-in-chat",
      })
      this.isMetadataManagerVisible = true;
      this.openTagMetadataModel = "share-in-chat";
      this.eOMenu = false;
    }, 
    // subClipsLengthCheck(id,catId){
    //   if(catId != undefined){
    //     let payload = {}
    //     payload.params = {asset_type:"subclip",master_asset_id:id,category_id:catId,"metadata":"metadata"}
    //     this.getSubclipsFromServer(payload).then((data) => {
    //         if(data.assets.length){
    //           return true;
    //         }else{
    //           return false;
    //         }
    //     })
    //   }
    //   return false;
    // },
    setUpContextMenuActions() {
      let actions = [];
      Array.prototype.push.apply(actions, this.getRegisteredBinsContextMenu());
      Array.prototype.push.apply(actions, this.getRegisteredExportContextMenu())
      Array.prototype.push.apply(
        actions,
        this.getRegisteredBinsMoreContextMenu()
      );
      Array.prototype.push.apply(
        actions,
        this.getRegisteredBinsNewContextMenu()
      );
      Array.prototype.push.apply(
        actions,
        this.getRegisteredBinsImportContextMenu()
      );
      Array.prototype.push.apply(
        actions,
        this.getRegisteredShareContextMenu()
      );
      Array.prototype.push.apply(
        actions,
        this.getRegisteredAIToolsContextMenu()
      )
      Array.prototype.push.apply(actions, this.getRegisteresOpenWithContextMenu())
      for (let contextMenu of actions) {
        if(contextMenu.action_name == "Archive Request"){
          let event = [
            {
              event_name: "onClick",
              event_handler: this.archiveRequest,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: event,
          });
        }else if(contextMenu.action_name == "Retrieve Request"){
          let event = [
            {
              event_name: "onClick",
              event_handler: this.retrieveRequest,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: event,
          });
        }else if(contextMenu.action_name == "Delivery to Target 1 Request"){
          let event = [
            {
              event_name: "onClick",
              event_handler: this.transcoderTarget1Request,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: event,
          });
        }else if(contextMenu.action_name == "Delivery to Target 2 Request"){
          let event = [
            {
              event_name: "onClick",
              event_handler: this.transcoderTarget2Request,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: event,
          });
        }
        else if(contextMenu.action_name == "manage-assets-links"){
          let assetLinksEvent = [
            {
              event_name: "onClick",
              event_handler: this.manageAssetLinks,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: assetLinksEvent,
          });
        }
        else if(contextMenu.action_name == "set-asset-label"){
          let setLabelEvents = [
            {
              event_name: "onClick",
              event_handler: this.setLabelToAsset,
              handler_args: [],
            },
          ]
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: setLabelEvents,
          })
        }else if (contextMenu.label == "Assets Report"){
          let assetsReportEvents = [{
            "event_name": "onClick",
            "event_handler": this.downloadAssetsReport,
            "handler_args":[]
          }]
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.id,
            onEvents: assetsReportEvents,
          })
        }else if(contextMenu.label == 'Outbox'){
          let outboxEvents = [{
            "event_name": "onClick",
            "event_handler": this.exportAssetstoOutbox,
            "handler_args":[]
          }]
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.id,
            onEvents: outboxEvents,
          })
        }
        else if (contextMenu.action_name == "RemoveFromTrash") {
          let removeFromTrashEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitRemoveFromTrash,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: removeFromTrashEvents,
          });
        }
        else if (contextMenu.action_name == "copy-link") {
          let copyURLEvents = [
            {
              event_name: "onClick",
              event_handler: this.copyAssetURL,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: copyURLEvents,
          });
        }
        else if(contextMenu.action_name == "Chat"){
          let shareInChat = [
            {
              event_name: "onClick",
              event_handler: this.openShareInChat,
              handler_args: [],
            }
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: shareInChat,
          });
        }else if(contextMenu.action_name == "Lock/Unlock"){
          if(contextMenu.label == 'Lock'){
            let shareInChat = [
              {
                event_name: "onClick",
                event_handler: this.lockSelectedAsset,
                handler_args: [],
              }
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.id,
              onEvents: shareInChat,
            });
          }else if(contextMenu.label == 'Unlock'){
            let shareInChat = [
              {
                event_name: "onClick",
                event_handler: this.unlockSelectedAsset,
                handler_args: [],
              }
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.id,
              onEvents: shareInChat,
            });
          }
        }
        else if (contextMenu.action_name == "Download") {
          let downloadEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitDownloadJob,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: downloadEvents,
          });
        }
        else if (contextMenu.action_name == "Download Proxy"){
          let downloadProxyEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitDownloadProxyAction,
              handler_args: [],
            },
          ]
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.id,
            onEvents: downloadProxyEvents,
          })
        }
        else if (contextMenu.action_name == "Archive") {
          let archiveEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitArchiveJob,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: archiveEvents,
          });
        }else if (contextMenu.action_name == "Folder Archive") {
          let folderArchiveEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitFolderArchiveJob,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: folderArchiveEvents,
          });
        }
        else if (contextMenu.action_name == "Retrieve") {
          let retrieveEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitRetrieveJob,
                handler_args: [],
              },
            ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: retrieveEvents,
          });
        }
        else if (contextMenu.action_name == "Retrieve As"){
          let retrieveAsEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitRetrieveAsAction,
              handler_args: [],
            },
          ]
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: retrieveAsEvents,
          }) 
         }
        else if(contextMenu.action_name == "Folder Retrieve"){
          let retrieveEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitFolderRetrieveJob,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: retrieveEvents,
          });
        }
        else if (contextMenu.action_name == "Transcode") {
          let partialRetrieveEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitPartialRetrieveAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.action_name,
                onEvents: partialRetrieveEvents,
              })
        }
        else if (contextMenu.action_name == "OCR") {
          let ocrEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitOCRAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.action_name,
                onEvents: ocrEvents,
              })
        }else if (contextMenu.action_name == "Transcript"){
          let transcriptEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitTranscript,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.action_name,
                onEvents: transcriptEvents,
              })
        }else if (contextMenu.action_name == "Object Detection") {
          let obdEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitOBDAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.action_name,
                onEvents: obdEvents,
              })
        }else if (contextMenu.action_name == "Face Detection") {
          let faceDetectionEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitFaceDetectionAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.action_name,
                onEvents: faceDetectionEvents,
              })
        }
        else if (contextMenu.action_name == "Copy") {
          let copyEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitCopyAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: copyEvents,
          });
        }
        else if (contextMenu.action_name == "RestoreFromTrash") {
          let restoreEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitRestoreFromTrash,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: restoreEvents,
          });
        }
        else if (contextMenu.action_name == "MoveToTrash") {
          let moveToTrashEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitMoveToTrash,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: moveToTrashEvents,
          });
        }
        else if (contextMenu.action_name == "Cut") {
          let cutEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitCutAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: cutEvents,
          });
        }
        else if (contextMenu.action_name == "Rename") {
          let renameEvents = [
            {
              event_name: "onClick",
              event_handler: this.renameAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: renameEvents,
          });
        }
        else if (contextMenu.action_name == "Upload") {
          let uploadEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitUploadAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: uploadEvents,
          });
        }else if (contextMenu.action_name == "Upload Version") {
          let assetNewVersionEvents = [
            {
              event_name: "onClick",
              event_handler: this.uploadAssetNewVersion,
              handler_args: [],
            },
          ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: assetNewVersionEvents,
            });
        }else if (contextMenu.action_name == "Update Version") {
          let assetExistVersionEvents = [
            {
              event_name: "onClick",
              event_handler: this.updateAssetNewVersion,
              handler_args: [],
            },
          ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: assetExistVersionEvents,
            });
        }
        else if (contextMenu.action_name == "CreateFolder") {
          let createFolderEvents = [
            {
              event_name: "onClick",
              event_handler: this.createFolderAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: createFolderEvents,
          });
        }
        else if (contextMenu.action_name == "tag-metadata") {
          let tagMetadataBinsEvents = [{
              event_name: "onClick",
              event_handler: this.tagMetadataBinsActions,
              handler_args: [],
            }];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: tagMetadataBinsEvents,
          });
        }
        else if(contextMenu.action_name == "tag-metadata-requestor"){
          let tMRBinsEvents = [{
              event_name: "onClick",
              event_handler: this.tMRuestorAction,
              handler_args: [],
            }];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: tMRBinsEvents,
          });
        }
        else if (contextMenu.action_name == "Bulk Field Update") {
          let tagMetadataBinsEvents = [
            {
              event_name: "onClick",
              event_handler: this.bulkTagMetadataBinsActions,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: tagMetadataBinsEvents,
          });
        }
        else if (contextMenu.action_name == "Preview") {
          let previewBinsEvents = [
            {
              event_name: "onClick",
              event_handler: this.previewBinsActions,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: previewBinsEvents,
          });
        }
        else if (contextMenu.action_name == "Mark For Delete" && this.isEnabled("Mark For Delete")) {
          let markForDeleteEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitMarkForDelete,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: markForDeleteEvents,
          });
        }
        else if (contextMenu.action_name == "Restore" && this.isEnabled("Restore")) {
          let restoreEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitRestore,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: restoreEvents,
          });
        }
        else if (contextMenu.action_name == "Delete Permanently" && this.isEnabled("Delete Permanently")) {
          let delPermEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitDeletePermanently,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: delPermEvents,
          });
        }
        else if (contextMenu.action_name == "Force Delete Permanently" && this.isEnabled("Force Delete Permanently")) {
          let forceDelPermEvents = [
            {
              event_name: "onClick",
              event_handler: this.submitForceDeletePermanently,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: forceDelPermEvents,
          });
        }
        else if (contextMenu.action_name == "Sub Clips") {
          let subclipsBinsEvents = [
            {
              event_name: "onClick",
              event_handler: this.subclipsBinsActions,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: subclipsBinsEvents,
          });
        }

        else if (contextMenu.action_name == "Review") {
          let reviewBinsEvents = [
            {
              event_name: "onClick",
              event_handler: this.reviewBinsAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: reviewBinsEvents,
          });
        }
        else if(contextMenu.action_name == "Share"){
          let shareCatalogEvents = [
            {
              event_name: "onClick",
              event_handler: this.shareWithUser,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: shareCatalogEvents,
          });
        }
        else if(contextMenu.action_name == "Share via Email"){
          let shareCatalogEvents = [
            {
              event_name: "onClick",
              event_handler: this.shareViaEmail,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: shareCatalogEvents,
          });
        }
        else if (contextMenu.action_name == "PAM") {
          let taskBinsEvents = [
            {
              event_name: "onClick",
              event_handler: this.tasksBinsAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: taskBinsEvents,
          });
        }
        else if (contextMenu.action_name == "Hype-SocialMedia") {
          let editAndShareEvents = [
            {
              event_name: "onClick",
              event_handler: this.editAndShareAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: editAndShareEvents,
          });
        }
        else if (contextMenu.action_name == "Modify TTL") {
          let modifyTTLEvents = [
            {
              event_name: "onClick",
              event_handler: this.modifyTTLAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: modifyTTLEvents,
          });
        }
        else if (contextMenu.action_name == "Manage Version") {
          let mediaVersionEvents = [
            {
              event_name: "onClick",
              event_handler: this.manageMediaVersion,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: mediaVersionEvents,
          });
        }
        else if (contextMenu.action_name == "manage-asset-annotaion") {
          let imageAnnotation = [
            {
              event_name: "onClick",
              event_handler: this.imageAnnotationAction,
              handler_args: [],
            },
          ];
          this.updateActionCallbacks({
            id: contextMenu.id,
            action_name: contextMenu.action_name,
            onEvents: imageAnnotation,
          });
        }

        /**
         *   Below code will override existing contextmenu click callback  with plugin callback
         *   Based on "contextmenu":{"contextMenuCallback":openOCRtranscriptContextmenu , "action_name":"OCR"} for eg here it will call openOCRtranscriptContextmenu at damplugin side
         */
        try{
            for(let pluginId in this.getRegisteredPluginMapper()){
                let plugin = this.getRegisteredPluginMapper()[pluginId];
                if(plugin && plugin.contextmenu && plugin.contextmenu.action_name == contextMenu.action_name){
                      let event = [
                      {
                        event_name: "onClick",
                        event_handler: plugin.contextmenu.contextMenuCallback,
                        handler_args: [],
                      },
                    ];
                    this.updateActionCallbacks({
                      id: contextMenu.id,
                      action_name: contextMenu.action_name,
                      onEvents: event,
                    });
                }
            }
        }catch(e){console.error("Some error occured while registering plugin contextmenu -->",e)}

      }
      this.eventsAttached = true;
    },
    getExportEventHandler(binInfo, eventName){
      if('action_name' in binInfo){
        this.getEventHandler(
          binInfo,
                'onClick',
                binInfo.onEvents
              )(eventName, Object.assign({},this.selectedFileInfo),  Object.assign({},this.selectedFiles),{boundComponent: this.getComponent})
        return
      }
      let filesList = [];
      if(Object.keys(this.selectedFileInfo).length){
        filesList = [this.selectedFileInfo]
      } else{
        filesList = this.getSelectedMultipleFilesAsList(this.selectedFiles)
      }
      for(let eachFile of filesList){
        let payload = {
          job_name : "Export",
          element_type : "file",
          file_name : eachFile.file_name,
          path : eachFile.path,
          export_to : [binInfo.bin_id]
        }
        this.createNewJob(payload).then((data) => {
          console.log("Export proxy job response: ", data.statusCode)
        });
      }
      this.$toast.success('Job sumitted successfully.')
    },
    getExportProxyEventHandler(binInfo, eventName){
      if('action_name' in binInfo){
        this.getEventHandler(
          binInfo,
                'onClick',
                binInfo.onEvents
              )(eventName, Object.assign({},this.selectedFileInfo),  Object.assign({},this.selectedFiles))
        return
      }
      let payload = {}
      if(Object.keys(this.selectedFileInfo).length){
        payload = {
          job_name : "Export Proxy",
          element_type : "file",
          file_name : this.selectedFileInfo.file_name,
          path : this.selectedFileInfo.path,
          export_to : [binInfo.bin_id]
        }
        this.createNewJob(payload).then((data) => {
          console.log(" Export proxy job : resp keys ",Object.keys(data) )
          if (data.statusCode == 200) {
            this.$toast.success("Export proxy job submitted successfully");
          } else {
            if(data.message){
              this.$toast.error(data.message);
            }else{
              this.$toast.error('Failed to submitted export proxy job.');
            }
          }
        });
      }else{
        let postedJobs = []
        for (const asset_id of Object.keys(this.selectedFiles)) {
          payload = {
            job_name : "Export Proxy",
            element_type : "file",
            file_name : this.selectedFiles[asset_id].file_name,
            path : this.selectedFiles[asset_id].path,
            export_to : [binInfo.bin_id]
          }
          let jobsPostPromise = this.createNewJob(payload)
          jobsPostPromise.file_name = this.selectedFiles[asset_id].file_name;
          postedJobs.push(jobsPostPromise)
        }
        Promise.all(postedJobs).then(allJobsList=>{
            let failedEntries = []
            let exportedEntries = []
            for(let i=0; i<allJobsList.length ; i++){
              let eachJob  = allJobsList[i]
              if (eachJob.statusCode == 200) {
                exportedEntries.push(eachJob)
              } else {
                failedEntries.push(eachJob.message)
              }
            }
            if(exportedEntries && exportedEntries.length > 0){
              this.$toast.success("Export proxy job submitted successfully");
            }
            if(failedEntries && failedEntries.length > 0){
              if(failedEntries.length == 1){
                this.$toast.error(`Failed to export proxy ${failedEntries[0]}.`)
              }else{
                this.$toast.error(`${failedEntries[0]} \n + Failed to export proxy  ${failedEntries.length-1} More files`);
              }
            }
        })
      }
      this.closeContextMenu();
    },
    getEventHandler(info, eventname, supportedEvents, isFromHover = false) {
      console.log(" ************** getEventHandler", info , eventname, supportedEvents)
      if (
        info != undefined &&
        info.dialogRequired != undefined &&
        info.dialogRequired
      ) {
        this.selectedExternalPluginInfo = info.pluginInfo;
        return this.openDialogForExternalPlugin;
      } else {
        let event = supportedEvents.filter(
          (eventInfo) => eventInfo.event_name == eventname
        );
        if (event.length != 0) {
            if(!isFromHover){
              this.closeContextMenu();
            }
          return event[0]["event_handler"];
        }
        return console.log;
      }
    },
    getFileInfoByfileuIdFromInMem(fileuid){
      let fileinfo = this.filesList.files.filter((file_)=>file_.file_uid==fileuid);
      if(fileinfo.length != 0){
          return fileinfo[0]
      }
      fileinfo = this.filesList.dirs.filter((file_)=>file_.file_uid==fileuid);
      if(fileinfo.length != 0){
          return fileinfo[0]
      }
      return {}
    },
    updateProxyForPath(notification){
      if(notification.message){
        let path = notification.message.path
        let fileinfo = this.filesList.files.filter((file_)=>file_.path==path);
        if(fileinfo.length != 0){
          console.log(`[updateProxyForPath][BinsBrowse][Proxy-Status-Update for path->${path} requested]`)
          this.refreshFilesList(this.currentFolderInfo)
        }
      }
    },
    preventSubMenuDisplay(){
        this.closeSubmenu();
    },
    isFolderExists(folderPath){
      let folderinfo = this.filesList.dirs.filter((file_)=>file_.path==folderPath);
      if(folderinfo.length != 0){
        return true
      }
      return false
    },
    handleAssetCreatedNotificaton(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let file_info = notification.message;
        if("master_asset_id" in file_info && file_info.master_asset_id != null){
          let file_exists = this.filesList.files.filter((file_)=>file_.asset_id==file_info.master_asset_id)
          if(file_exists.length > 0){
              file_exists[0].subclips_present = true;
          }
        }
    },
    handleBinRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let bin_info = notification.message
        if (notification.message_type == NotifierConstants.binRemovedNotification){
          if(bin_info.bin_id == this.selectedBinId){
            this.$toast.info("Selected bin is deleted by other user")
          }
        }
      }
    },
    handleFileCreateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let parent_path = notification.message.parent_path
        let add_to_list = false
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            add_to_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          add_to_list = true
        }
        if (add_to_list){
          console.log(`[handleFileCreateNotification][BinsBrowse][New File Created in path->${parent_path}]`)
          if(document.getElementsByClassName("advanced-search-wrapper").length == 0){
            this.addToFileList(notification.message, true)
          }
        }
      }
    },
    handleFileUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let path = notification.message.path
        let parent_path = notification.message.parent_path
        let update_to_list = false
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            update_to_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          update_to_list = true
        }
        if (update_to_list){
          console.log(`[handleFileUpdateNotification][BinsBrowse][File(${path}) updated in path->${parent_path}]`)
          this.updateFileList(notification.message, false)
          if (notification.message.state == "MARK FOR DELETE"){
            let fileStateFromFilter = JSON.parse(localStorage.getItem('file-status-filter-state'));
            if(fileStateFromFilter && Object.keys(fileStateFromFilter).length){
              if(fileStateFromFilter.state && !(fileStateFromFilter.state.includes('MARK FOR DELETE'))){
                this.removeFromFileList(notification.message, true)
              }
            }
          }
        }
      }
    },
    handleAssetRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if("master_asset_have_subclips" in notification.message && "master_asset_id" in notification.message){
        let asset_id_check = this.filesList.files.filter((asset)=>asset.asset_id==notification.message.master_asset_id)
        if(asset_id_check.length > 0){
              if(notification.message.master_asset_have_subclips == false)
                asset_id_check[0].subclips_present = false;
          }
        }
    },
    handleFileRemovedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let path = notification.message.path
        let parent_path = notification.message.parent_path
        let remove_from_list = false
        if (this.currentFolderInfo.path == undefined){
          if (parent_path == `share://${this.binSelected}`){
            remove_from_list = true
          }
        }else if(this.currentFolderInfo.path == parent_path){
          remove_from_list = true
        }
        if (remove_from_list){
          console.log(`[handleFileRemovedNotification][BinsBrowse][File(${path}) removed in path->${parent_path}]`)
          this.removeFromFileList(notification.message, true)
        }
      }
    },
    handleFileOutdatedNotifiation(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let file_info = notification.message.file_info;
        this.filesList.files = this.filesList.files.filter((file_)=>file_.path != file_info.path);
      }
    },
    handleFileArchivedNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let job_info = notification.message
      let job = this.filesList.files.filter((job_)=>job_.path == job_info.path);
      if (job.length != 0){
        job = job[0];
        job.storage_class = job_info.storage_class;
        job.archived = job_info.archived;
      }
    },
    handleJobUpdateNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let job_info = notification.message
      if(job_info.job_name == "Lock/Unlock" && job_info.state == 'COMPLETED'){
        if('file_uid' in job_info && job_info.file_uid.length > 0){
          // Iterate over the assetsList
          this.filesList.files.forEach(file => {
            // Check if the _id exists in array job_info.file_uid
            if (job_info.file_uid.includes(file.file_uid)) {
              // Add the 'lock' property to the matched entry
              this.$set(file, 'lock', job_info.asset_lock);
            }
          });
        }
      }
    },
    registertoWSListener(){
      this.addWSEventListener({eventname:["JOB_STATUS_UPDATE"], callback:this.handleJobUpdateNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileCreatedNotification, callback:this.handleFileCreateNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileOutdatedNotification, callback:this.handleFileOutdatedNotifiation,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileRemovedNotification, callback:this.handleFileRemovedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.binRemovedNotification, callback:this.handleBinRemovedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleFileArchivedNotification,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:NotifierConstants.assetCreatedNotification, callback:this.handleAssetCreatedNotificaton,parent:"BinsBrowse"})
      this.addWSEventListener({eventname:[NotifierConstants.assetRemovedCreatedNotification,NotifierConstants.assetOutdatedNotification], callback:this.handleAssetRemovedNotification,parent:"BinsBrowse"})
    },
    UnregistertoWSListener(){
      this.removeWSEventListener({eventname:["JOB_STATUS_UPDATE"], callback:this.handleJobUpdateNotification,parent:"BinsBrowse"})
      this.removeWSEventListener({eventname:NotifierConstants.fileCreatedNotification, callback:this.handleFileCreateNotification,parent:"BinsBrowse"})
      this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"BinsBrowse"})
      this.removeWSEventListener({eventname:NotifierConstants.fileOutdatedNotification, callback:this.handleFileOutdatedNotifiation,parent:"BinsBrowse"})
      this.removeWSEventListener({eventname:NotifierConstants.fileRemovedNotification, callback:this.handleFileRemovedNotification,parent:"BinsBrowse"})  
      this.removeWSEventListener({eventname:NotifierConstants.binRemovedNotification, callback:this.handleBinRemovedNotification,parent:"BinsBrowse"})
      this.removeWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleFileArchivedNotification,parent:"BinsBrowse"})
      this.removeWSEventListener({eventname:NotifierConstants.assetCreatedNotification, callback:this.handleAssetCreatedNotificaton,parent:"BinsBrowse"})
      this.removeWSEventListener({eventname:[NotifierConstants.assetRemovedCreatedNotification,NotifierConstants.assetOutdatedNotification], callback:this.handleAssetRemovedNotification,parent:"BinsBrowse"})
    },
    async handleBrowse(){
      let params = {}, route_params = Object.assign({}, this.$route.params), query=Object.assign({}, this.$route.query)
      this.searchKeyword = query.keyword?query.keyword:null
      this.$emit("retainSearchedKeywordToExplorer", this.searchKeyword);
      if (!(route_params.selectedBinId)){
        route_params.selectedBinId = route_params.bin_id
      }
      if (!(route_params.file_name)){
        route_params.file_name = this.getFileName(route_params)
      }
      
      if (!(route_params.permissions)){
        route_params.permissions = this.currentFolderInfo.permissions?this.currentFolderInfo.permissions:"full-control"
      }

      if (!(route_params.selectedBinId)){
        route_params.selectedBinId = route_params._id
        this.selectedBinId = route_params._id
      }
      
      this.currentPage = query.page?query.page:1

      try {
          this.advanceSearchKeys = JSON.parse(query.advanceFilter)
      } catch  {
          this.advanceSearchKeys = {}
      }
      let binInfo = this.rootBins.find(op=>op.bin_id == route_params._id)
      if(binInfo){
        this.binSelected = route_params._id
        params = {bin_id:route_params._id}
      }else{
        params = {_id:route_params._id}
      }
      this.loadData(params);
    },
    fetchDeploymentBinsFromServer(){
      this.deploymentBinsList = []
      this.rootBins = []
      let payload = {};
      payload.params = {status:"active",filter:JSON.stringify(["bin_type"])}
      return new Promise((resolve,reject)=>{
        this.getAllBinsFromServer(payload).then((data)=>{
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            this.deploymentBinsList = data.bins.filter(op=>op.bin_type == "deployment");
            this.rootBins = data.bins.filter(op=>op.bin_type == "asset")
            resolve(data.bins)
          }else{
              reject({"error": "Unable to load favorites."})
            }
        });
      })
    },
    reloadThePage(){
      this.unselectAllFiles();
      this.handleBrowse();
    },
    ...mapActions("bins",["getAllBinsFromServer"]),
    ...mapActions("files", ["getAllFilesFromServer", "getFileInfoFromServer", "getFolderStructureFromFileUID"]),
    ...mapActions("jobs", ["createNewJob"]),
    ...mapGetters("privileges", ["getPrivilegeFromInMem"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapGetters("registry", [
      "getRegisteredBinsContextMenu",
      "getRegisteredBinsMoreContextMenu",
      "getRegisteredBinsImportContextMenu",
      "getRegisteredBinsNewContextMenu",
      "getRegisteredShareContextMenu",
      "getRegisteredAIToolsContextMenu","getRegisteredExportContextMenu","getRegisteredPluginMapper", "getRegisteresOpenWithContextMenu"
    ]),
    ...mapMutations("bins",["setSelectedPath","setPermissionOfSelectedBin"]),
    ...mapMutations("actions", [
      "setPasteActionsinfo",
      "unsetPasteActionsinfo",
    ]),
    ...mapMutations("registry", ["updateActionCallbacks", "removeBinMoreContextMenu","exposeDamComponents"]),
    ...mapMutations("locations", [
      "setLocationHash",
      "unsetLocationHash",
      "changeLocationCallback",
      "unsetLocationChangeEventListenerCallback",
    ]),
    ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
    ...mapMutations("websocket",["addWSEventListener","removeWSEventListener"]),
    ...mapMutations("files",["setfolderInfoToGetCurrentPath"]),
    ...mapActions("assets", ["getSubclipsFromServer", "downloadAssetsReportFromServer", "updateLabelsForArchiveRequest", "updateLabelsForRetrieveRequest", "updateLabelsForTranscoderTarget1Request", "updateLabelsForTranscoderTarget2Request", "exportFilesToOutbox"]),
    ...mapGetters("pools", ["getPoolsfromInMem", "getPoolDevicesfromInMem"]),
    ...mapMutations("download",["setDownloadFilesArr"])
  },
  
  async created() {
    this.registertoWSListener()
    this.setSelectedPath("share://"+this.selectedBinId);
    this.globalSearchKeyword = this.searchKeyword;

    const savedSortBy = localStorage.getItem("bins_sort_by_value");
    if (savedSortBy) {
      try {
        this.sortBy = JSON.parse(savedSortBy);
      } catch (error) {
        console.error("Invalid bins_sort_by_value in localStorage", error);
      }
    }
    
    try{
        await this.fetchDeploymentBinsFromServer();
      }catch(e){console.log("Error while loading bins in bin browse workspace",e)}
    this.handleBrowse();
    this.exposeDamComponents({bins:()=>{return this}});
  },
  mounted() {
    this.$emit("selectedSingleFile", {});
    this.$emit("selectedMultipleFiles", {});
  },
  beforeDestroy() {
    // this.unsetLocationHash();
    Utils.saveFolderHistory([]);
    // Utils.unsetCookie("traverseHistory")
    // this.unsetLocationChangeEventListenerCallback();
    this.UnregistertoWSListener()
    this.isdestroyed = true;
  },
  props: ["selectedBinId", "refreshFileInfoAndShowAsset", "viewType","ref","isAdvancedSearchEnabled", "getCookieValueOfJobPanel"],
  data() {
    return {
      eOMenu:false,
      eventsAttached: false,
      isLoaded: false,
      isdestroyed: false,
      loadFromCookie: true,
      filesList: { dirs: [], files: [] },
      binSelected: null,
      isActive: null,
      page: 1,
      filesAndFoldersList: [],
      selected: [],
      currentPage:1,
      isMetadataManagerVisible: false,
      totalPages: -1,
      totalFiles: -1,
      perPage: -1,
      folderStructure: [],
      currentFileInfo: {},
      showMenu: false,
      x: 0,
      y: 0,
      submenuX: 0,
      submenuY: 0,
      submenuNewX: 0,
      submenuNewY: 0,
      submenuImportX: 0,
      submenuImportY: 0,
      contextMenuItems: [],
      subMenuItems: [],
      subMenuExportItems:[],
      subMenuExportProxyItems:[],
      subMenuNewItems: [],
      subMenuImportItems: [],
      subMenuArchiveItems:[],
      subMenuRetrieveItems:[],
      deploymentBinsList: [],
      rootBins:[],
      currentFolderInfo: {},
      selectedFileInfo: {},
      showMoreSubMenu: false,
      showNewSubMenu: false,
      showImportSubMenu: false,
      showExportSubMenu: false,
      showExportProxySubMenu: false,
      showArchiveToSubMenu:false,
      showOpenWithToolSubmenu:false,
      showRetrieveFromSubmenu:false,
      selectedExternalPluginInfo: {},
      options: { chunk: 5 },
      growingFileGif: Utils.getLoadingGif(),
      markForDeleteIcn: Utils.getMarkForDeleteIcon(),
      selectedFiles :{},
      dragSelected:false,
      currentPathInfo:null,
      sortBy:{label:'Relevance',sortOn:'added_datetime',ascDesc:-1},
      globalSearchKeyword: "",
      openSubclips:false,
      openVideoTranscript:false,
      showFolders:true,
      showFiles:true,
      resizeObserver:null,
      advanceSearchKeys:null,
      searchKeyword:null,
      openTagMetadataModel:null,
      vdialogComponents:["retrieve-as","create-folder", "rename-folder","metadata-requestor","edit-and-share","modify-ttl","manage-version", "manage-assets-link", "set-label-to-asset"],
      ModalParentRoute:{},
      routerComponentMapper:{
        "bulk-tagmetadata-manager":this.bulkTagMetadataBinsActions,
        "external-plugin-manager":this.openDialogForExternalPlugin,
        "metadata-manager":this.tagMetadataBinsActions,
        "new-review":this.reviewBinsAction,
        "PartialRetrieve":this.submitPartialRetrieveAction,
        "bins-metadata-dock-video-transcript-manager": this.submitBinsSubclipTranscript,
        "properties":this.openProperties,
        "share-in-chat": this.openShareInChat,
        "OCR": this.submitOCRAction,
        "file-object-detection": this.submitOBDAction,
        "file-facedetection":this.submitFaceDetectionAction,
        "VideoTranscript":this.submitTranscript,
        "AudioTranscript":this.submitTranscript,
        "bin-sub-clips-manager": this.subclipsBinsActions,
        "metadata-dock-bin-sub-clips-manager": this.subclipsBinsActionsThroughMetadataDock,
        "share-with-user":this.shareWithUser,
        "share-via-email":this.shareViaEmail,
        "share-with-user-from-global-btn": this.shareWithUserFromGlobalBtn
      },
      assetsState:null,
      altoLogo:Utils.getAltoLogo(),
      lastClosedDialogMap:{isAssetUnselectRequired:true,modalName:''},
      allFilesSelected:false,
      showFoldersInListView:true,
      showFilesInListView:true,
      showShareSubmenu: false,
      showAIToolsSubmenu:false,
      subMenuShareItems: [],
      subMenuAIToolItems:[],
      subMenuOpenWithItems:[],
      rootPathPermission:null,
      storyboardPreviewActiveId:null,
      enableCustomMessage:false
    };
  },
};
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $secondary-border-color: 1px solid #2b2b2b;
  $row-border-color: #212121;
  $secondary-border-color:#767676;


@mixin storage-image-styles {
    height: 18px !important;
    width: 16px !important;
    border-radius: 5px !important;
    object-fit: contain;
    margin: 3px;
}

.keyword-highlight-wrapper{
    text-align: start;
    margin-inline-start: 6px;
    margin-top: -24px;
    color: $dull-text-color;
    font-size: 11px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.activeAsset.active-list-view ,
.activeMultipleAssets {
  border: 1px solid $row-border-color !important;
  background: $bg-color-on-hover;
  border-radius: 5px !important;
  td:first-child,
  th:first-child {
    border-radius: 10px 0 0 10px;
  }

  // Set border-radius on the top-right and bottom-right of the last table data on the table row
  td:last-child,
  th:last-child {
    border-radius: 0 10px 10px 0;
  }
  .thumbnail-data {
    float:inline-start;
    background: #1879e28c !important;
    position: relative;
    width: 102%;
    inset-inline-start: -4px;
    .svg-icons-display{
      inset-inline-end:0px;
      bottom:-1px;
    }
  }
}

.activeAsset,
.activeMultipleAssets {
  border: 2px solid #037afb;
  border-radius: 5px !important;
  .thumbnail-data {
    background: #1879e28c !important;
    position: relative;
    width: 102%;
    inset-inline-start: -4px;
    .svg-icons-display{
      inset-inline-end:0px;
      bottom:-1px;
    }
  }
}


.activeAsset.active-list-view {
  color: $active-blue;
  border: none !important;
}
.activeAsset.active-list-view .overWriteShortcutIconWrapper{
      visibility: visible !important;
    }
// .thumbnail-view-ul{
//   li:hover{
//     border: $border-color;
//     border-radius: 5px;
//   }
// }
.thumbnail-view-ul {
  list-style-type: none;
  display: inline-flex;
  flex-wrap: wrap;
  padding: 0px;
  margin-top: 0px;
  width: 100%;
  padding-inline-start: 20px;
  justify-content: start;
  // overflow: auto;
  // position:relative; 
  li {
    display: inline-block;
    margin-inline-end: 10px;
    width: 174px;
    padding-inline-start: 5px;
    margin-top: 5px;
    height: 128px;
    .asset-thumbnail {
      height: 93px;
      width: 160px;
      border-radius: 7px;
      margin-top: 8px;
      //border: $border-color;
      position:relative;
      img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 7px;
        object-fit: contain;
        border-radius: 7px;
      }
    }
    .thumbnail-data {
      text-align: center !important;
    }
  }
}

.folder-view-ul {
  padding-top: 10px;
  margin-bottom: 10px;
  .folder-view-li {
    display: inline-flex !important;
    height: 52px !important;
    border: $border-color;
    border-radius: 6px;
    .folder-view {
      font-size: 30px;
    }
    .folder-data {
      margin-top: 15px;
      margin-inline-start: 7px;
      width: 118px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
    }
  }
}

.folder-view-li:hover{
  border: 1px solid $secondary-border-color !important;
}

.activeFolder, .activeFolder:hover {
  border: 1px solid $active-blue !important;
  // color: $active-blue !important;
  .folder-view {
    svg {
      color: $active-blue !important;
    }
  }
}

.assets-view-wrapper {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
  width: 100%;
}

.list-view-wrapper {
  overflow: auto;
  display: inline-block;
  width: 100%;
  .shortcut-actions-type-icons-wrapper{
    inset-inline-end:-8px !important;
  }
}

.storage-type-icons-wrapper,.storage-type-icons-wrapper-list-view{
  position: absolute;
  svg,img{
    margin:3px;
  }
}

.storage-type-icons-wrapper-list-view{
  color: $dull-text-color;
  inset-inline-end: 0px;
  display: flex;
  img{
    @include storage-image-styles;
  }
}

.storage-type-icons-wrapper{
  color: #999;
  background: #1a1a1ab3;
  min-width: 30px;
  width: auto;
  inset-inline-end: -2px;
  bottom: -2px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 4px;
  display:flex;
  justify-content: center;
  img{
    @include storage-image-styles;
  }
  svg{
    margin:3px;
  }
}
    .shortcut-actions-type-icons-wrapper{
        visibility: hidden;
        color: #999;
        background: #000000c9;
        min-width: 30px;
        width: auto;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        position: absolute;
        top: 6px;
        inset-inline-end: 6px;
        line-height: 1;
        margin-inline-start: 8px;
        border: unset;
        --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
        box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
        display: flex;
        padding: 2px;
        border-radius: 0.375em;
        svg{
            margin-inline-start: 6px;
            margin-inline-end: 6px;
        }
    }
    .asset-thumbnail:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
        }
    }
    .overflow-parent-div {
      .overflow-menu{
        background: $secondary-background-color;
        font-size: 14px !important;
        border: $border-color;
        top: 19px;
        display: inline-block;
        inset-inline-start: calc(100% - 25px);
        padding-top: 3px !important;
        // visibility: hidden;
      }
    }
    .thumbnail-hw-set:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
        }
    }
    .shortcut-actions-type-icons-wrapper svg:hover{
        fill: #fdfff4;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action:hover{
        color: #fdfff4;
    }
    .shortcut-actions-type-icons-wrapper .copy-link-action{
        color: #a3adad;
    }
    .activeCatalog .overWriteShortcutIconWrapper{
      visibility: visible !important;
    }
// //pagination
::v-deep {
    .view-tags {
    font-size: 12px !important;
    height: 24px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border: $border-color !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 2px !important;
    text-align: center;
    width: auto !important;
    justify-content: center;
    span {
      padding: 0px 8px !important;
      margin-inline-start: 0px !important;
      font-size: 12px !important;
      border-radius: 15px !important;
      position: relative !important;
      top: 1px !important;
    }
  }
  font[color~=OrangeRed] {
      color: $highlight-font-color !important;
  }
  .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-end;
    margin-inline-start: 5px;
    position: relative;
    top:5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    min-width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .deployment-bins{
    visibility: hidden;
  }
  .deployment-bins:hover{
    visibility: visible;
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 225px !important;
    z-index: 9999 !important;
    overflow:auto;
    max-height:85vh;
  }

  .theme--dark.v-list{
    background: $secondary-background-color;
  }


.vmenuOnHover .v-list-item:hover .v-list-item__title{
              color:#fdfff4!important;
}
.vmenuOnHover{
      padding:0px !important;
      font-size: 14px!important;
      border: 1px solid #757575;
      background: #15181b !important;
    .v-list-item{
      text-align: start;
      min-height: 37px !important;
      padding: 0 10px !important;
      font-size: 12px !important;
      border: 0px solid #2b2b2b !important;
        .v-list-item__title{
              font-size: 14px !important;
              color:#a3adad !important;
        }
      }
    .v-menu__content{
      width:205px !important;
      z-index: 9 !important;
    }
  }
 // for multiselect
  div[data-drag-box-component]{
      z-index:100;
  }
}

.icon-background-on-hover:hover{
  background: #d1d2d31a;
}

.icon-background-on-hover{
  padding: 6px;
  height: 28px;
  width: 28px;
  border-radius: 4px;
}



.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  margin: 0px 15px;
  thead {
    color: $dull-text-color !important;
    position: relative;
    width: 100%;
    th {
      position: sticky;
      top: 0;
      background: $primary-background;
      z-index: 1;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr {
      height: 60px;
    }
  }
}

.table {
  th {
    border-top: none !important;
  }
  td {
    border-top: none !important;
  }
}

.table-with-border {
  thead {
    border-bottom: $border-color;
  }
  tr {
    border-bottom: $border-color;
  }
}

.asset-thumbnail-hw-set{
  // height:68px;
  height:78px;
  width:130px;
  border-radius: 7px;
  // margin-bottom:10px;
  //border: $border-color;
  display: inline-flex;
  .thumbnail-hw-set {
    // height: 68px;
    // width: 120px;
    // border-radius: 93%;
    // position: relative;
    height:100%;
    width:100%;
    position: relative;
    align-items: center;
    display: inline-flex;
    justify-content:center;
    img {
      // height: 100%;
      // width: 100%;
      // border-radius: 7px;
      max-width: 100%;
      max-height: 100%;
      border-radius: 7px;
      object-fit: contain;
      border-radius: 7px;
    }
  }
}  

input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block;
  width: 22px;
  height: 21px;
  margin-top: -1px;
  margin-inline-start: -1px;
  border: $border-color;
  border-radius: 0.25em;
  background: $primary-background;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.thumbnail-data {
  svg {
    border-radius: 5px;
    height: 100%;
    width: 100%;
  }
}

.reduce-opacity{
  opacity: 0.5;
}

.svg-icons-display {
  height: 20px;
  width: 20px;
  position: relative;
  opacity: 0.8;
  inset-inline-end: 5px;
}

.file-name {
  white-space: nowrap;
  max-width: 81%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: initial;
  position: relative;
  inset-inline-start:2px;
  top: 2px;
}

.file-name-display-styles-in-list-view{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: initial;
    position: absolute;
    // inset-inline-start:21px;
    // top: 2px;
    width:80%;
    margin-inline-start: 20px;
}


.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
.bigger-checkboxes:focus{
  box-shadow: unset;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}
  
.thumbnail-view-resolution-label{
    color: #eee;
    position: absolute;
    top: 0px;
    inset-inline-start:0px;
    font-size: 10px;
    padding: 1px 5px;
    justify-content: center;
    display: flex;
    border-radius: 7px;
    align-items: center;
    margin: 2px;
  }
  .res-FHD{
    // background: rgba(248, 120, 0, 0.6) !important;
    background: #f87800 !important;
    border: 1px solid #4a4a4a;
  }
  .res-fourK{
    background: #f8090199 !important;
    border: 1px solid #4a4a4a;
    //background: rgba(248, 9, 1, 0.6) !important;
  }
  .res-HD{
    // background: rgba(245, 241, 4, 0.6) !important;
    background: #f5f10499 !important;
    border: 1px solid #4a4a4a;
    color: #292a2b !important;
  }
  .res-SD{
    // background: rgba(29, 134, 140, 0.952) !important;
    background: #1d868cf3 !important;
    border: 1px solid #4a4a4a;
  }

.display-label{
  height: 22px;
  width: fit-content;
  border: 1px solid #F49D1A;
  border-radius: 10px;
  padding: 3px 9px;
  color: #F49D1A;
  font-size: 10px;
  letter-spacing: 0.5px;
}

.dull-the-text{
    color: $secondary-text-color;
  }

.file-extension{
  margin-inline-start: 5px;
  color: #aba7a7 !important;
  margin-top:2px
}
.file-extension-thumbnail-view{
  min-width: 51px;
  margin-inline-start: 5px;
  color: #aba7a7 !important;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dynamic-slug-name{
  margin-top:2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
